/* Histozing AI Canvas · product page studio for sections/hzai-canvas.liquid (prefix hzai).
   The gallery IS the AI studio: the example art on a wall → the customer's photo while the AI paints
   → their art on a canvas on the wall, with a close-up, all sizes to scale, before & after, photo guide.
   Size and frame are the product's own variants; the art goes to the cart as line item properties
   (_ai_job, _ai_recipe, _Preview, Name on art, Customer Instruction; "_" keeps a property away from the customer).
   A chosen photo waits for "Create my art"; nothing is painted on upload. The AI is the Cloudflare backend (setting "Địa chỉ API"):
     POST {api}/storefront/previews?recipe=&device=&ts=&sig=[&lettering=][&instruction=]   body = the photo   -> 202 {id, status, tokens_left}
     GET  {api}/storefront/previews/<id>, every 3 s      -> {status: processing|ready|failed, stage, art, error, tokens_left}
     GET  {api}/storefront/previews/<id>/art             -> the painting (also the Preview link)
   The start call carries &device= (a random id kept in this browser), &ts= (the Turnstile token, when a site
   key is set), &sig= (anti-spam signals, base64url JSON: see README "Chống spam"), &lettering= (a name the AI
   paints on the art, up to 40 characters; the backend's lettering text) and &instruction= (the customer's
   wishes for the picture, up to 1000 characters) in the query string, so no custom header needs a CORS rule
   on the backend. The backend answers 400 (recipe or device), 403 (Turnstile, or {error: "blocked"}),
   413 (over 15MB), 415 (not JPG / PNG / WebP), 429 (no previews left today, or {retry_after}) and 503 (the
   shop's daily cap); a failed job carries an error the customer can read.
   Test mode (section setting): no backend; the "art" is the photo tinted and stamped TEST.
   Plain ES5, no library; each section on the page boots on its own (and again on shopify:section:load). */
(function () {
'use strict';

function boot(root) {
  if (root.__hzai) return;
  root.__hzai = true;
  var cfgEl = root.querySelector('[data-hzai-config]');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ---------------------------------------------------------------- helpers */
  function q(n) { return root.querySelector('[data-hz="' + n + '"]'); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function mk(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function hq(c) { var x = c.getContext('2d'); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; return x; }
  function free(c) { if (c && c.getContext && !c.keep) { c.width = c.height = 0; } }   /* iOS keeps canvas memory until the size is zeroed */
  function rng(seed) { var a = seed >>> 0; return function () { a = (a + 0x6D2B79F5) | 0; var t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }
  function hexRGB(h) { h = h.replace('#', ''); var n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function shade(h, f) { var c = hexRGB(h); return 'rgb(' + c.map(function (v) { return Math.round(f <= 1 ? v * f : v + (255 - v) * (f - 1)); }).join(',') + ')'; }
  function loadImg(src) { return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  function isPhone() { return window.matchMedia('(max-width:860px)').matches; }
  function low(s) { return String(s == null ? '' : s).toLowerCase().trim(); }
  var toastT = 0;
  function toast(m) { var t = q('toast'); if (!t) return; t.textContent = m; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3200); }
  function track(ev, props) {
    var e = { event: 'hzai_' + ev }, k;
    if (props) for (k in props) e[k] = props[k];
    try { (window.dataLayer = window.dataLayer || []).push(e); } catch (err) {}
  }
  /* Shopify money format, e.g. "${{amount}}"; wrapped in .money so a currency app can convert it */
  function money(cents) {
    var f = String(C.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var n = (cents || 0) / 100;
    function fmt(d, th, dec) {
      var p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.length > 1 ? p[0] + dec + p[1] : p[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return fmt(2, "'", '.');
      return fmt(2, ',', '.');
    });
  }
  function moneyHtml(cents) { return '<span class="money">' + esc(money(cents)) + '</span>'; }
  /* the store's currency app (Nova, window.baCurr) converts .money once, on load. After the page redraws a price
     it is asked again, or the customer sees $ next to ₫ (calling it twice converts nothing twice) */
  var curT = 0;
  function convertMoney() {
    clearTimeout(curT);
    curT = setTimeout(function () { try { var b = window.baCurr; if (b && typeof b.refreshConversion === 'function') b.refreshConversion(); } catch (e) {} }, 30);
  }

  /* ---------------------------------------------------------------- the product: sizes and frames are its variants */
  var P = C.product || {}, VARIANTS = P.variants || [];
  var OPTS = (P.options || []).map(function (o) { return low(typeof o === 'string' ? o : o && o.name); });
  var iSize = OPTS.indexOf(low(C.sizeOption)), iFrame = OPTS.indexOf(low(C.frameOption));
  function optOf(v, i) { return i < 0 ? '' : (v.options ? v.options[i] : v['option' + (i + 1)]); }
  function uniq(i) { var out = []; VARIANTS.forEach(function (v) { var o = optOf(v, i); if (out.indexOf(o) < 0) out.push(o); }); return out; }
  /* 8×10", 11x14 in, 16 X 20 → inches; a size that does not read as W×H turns "Compare sizes" off */
  function dims(name) { var m = String(name).match(/(\d+(?:\.\d+)?)\s*["”']?\s*[x×X]\s*(\d+(?:\.\d+)?)/); return m ? { w: +m[1], h: +m[2] } : null; }
  var SIZES = (iSize < 0 ? [''] : uniq(iSize)).map(function (n) { var d = dims(n); return { id: n, name: n, w: d ? d.w : 12, h: d ? d.h : 16, ok: !!d }; });
  function ringOf(name) {
    var n = low(name);
    if (!n) return null;
    if (/black/.test(n)) return 'black';
    if (/white/.test(n)) return 'white';
    if (/wood|oak|walnut|natural/.test(n)) return 'wood';
    return null;
  }
  var FRAMES = (iFrame < 0 ? [''] : uniq(iFrame)).map(function (n) { return { id: n, name: n, ring: ringOf(n) }; });
  var NO_FRAME = FRAMES.filter(function (f) { return !f.ring; })[0] || null;
  function sizeOf(id) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].id === id) return SIZES[i]; return SIZES[0]; }
  function frameOf(id) { for (var i = 0; i < FRAMES.length; i++) if (FRAMES[i].id === id) return FRAMES[i]; return FRAMES[0]; }
  function variantFor(size, frame) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if ((iSize < 0 || optOf(v, iSize) === size) && (iFrame < 0 || optOf(v, iFrame) === frame)) return v;
    }
    return null;
  }
  var MIN_PRICE = VARIANTS.reduce(function (a, v) { return Math.min(a, v.price); }, Infinity);

  /* ---------------------------------------------------------------- state */
  var S = {
    photo: null,      /* {canvas, file, orig, name} the customer's photo: the current version's, or the one being painted */
    pend: null,       /* a photo chosen but not painted yet: it waits for "Create my art" */
    example: null,    /* the example art (an image), shown before any upload */
    versions: [],     /* [{img, job, url}] one per photo */
    ver: 0, gen: 'idle', view: 0, pct: 0, apiStage: '',
    size: '', frame: '', qty: 1,
    addOns: { tee: false, mug: false }, tee: null, mug: null,
    digitalOnly: false, upT0: 0,
    byHash: {}        /* photo hash + instruction -> version index: the same pair twice reuses its version */
  };
  var MAXQTY = 10;
  (function pickStart() {
    var v = null, id = +C.variant, fromUrl = /[?&]variant=\d+/.test(location.search);
    S.picked = fromUrl;   /* a link to one variant has picked it already */
    VARIANTS.forEach(function (x) { if (x.id === id) v = x; });
    v = v || VARIANTS[0] || {};
    S.size = optOf(v, iSize) || SIZES[0].id;
    S.frame = optOf(v, iFrame) || FRAMES[0].id;
    if (!fromUrl) {
      /* no ?variant= in the link: start on the popular size, and never on a pre-ticked frame */
      if (C.popular && SIZES.some(function (s) { return s.id === C.popular; })) S.size = C.popular;
      if (NO_FRAME) S.frame = NO_FRAME.id;
    }
  })();
  function curVer() { return S.versions.length ? S.versions[S.ver] : null; }
  function curImg() { var v = curVer(); return v ? v.img : S.example; }

  /* tokens: the backend keeps the real count (tokens_left in its answers); until it answers, this
     browser counts per recipe per day. Test mode never counts, so testing never runs dry */
  var TOK_KEY = 'hzai_used_' + (C.recipe || 'x') + '_' + new Date().toISOString().slice(0, 10);
  function readUsed() { if (C.test) return 0; try { return +(localStorage.getItem(TOK_KEY) || 0); } catch (e) { return 0; } }
  function writeUsed(n) { if (C.test) return; try { localStorage.setItem(TOK_KEY, String(n)); } catch (e) {} }
  S.tokens = Math.max(0, (C.tokens || 5) - readUsed());
  /* tokens one painting costs (section setting). The backend counts paintings, so its tokens_left × COST = tokens */
  var COST = Math.max(1, Math.round(+C.cost || 1));
  function tokWord(n) { return n + ' token' + (n === 1 ? '' : 's'); }

  /* ---------------------------------------------------------------- anti-spam
     Everything here only helps the backend tell a person from a spammer: it sends these hints with
     every start (&sig=), counts and decides. A script can fake them, so the real locks stay on the
     server (Turnstile, limits per IP / device / customer, the daily spend cap). The page itself only
     adds 3 polite guards: the same photo with the same instruction reuses its version, 8 s between
     starts, and it waits out a block the backend asked for. */
  var DAY = new Date().toISOString().slice(0, 10), T_LOAD = Date.now(), UI_EVENTS = 0, STARTED = 0, COOLDOWN_MS = 8000;
  /* a file dropped on the page counts too: someone who only drags a photo in still did something real */
  ['pointerdown', 'keydown', 'touchstart', 'drop'].forEach(function (ev) {
    window.addEventListener(ev, function () { if (UI_EVENTS < 999) UI_EVENTS++; }, { passive: true, capture: true });
  });
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function cookieGet(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function cookieSet(k, v) { try { document.cookie = k + '=' + encodeURIComponent(v) + '; Max-Age=31536000; Path=/; SameSite=Lax'; } catch (e) {} }
  function rid() { return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  /* one device id, kept twice (localStorage + a first-party cookie): the backend sees both as they were
     when the page opened, so one missing or the two different = someone cleared their storage */
  var ID_LS = lsGet('hzai_device') || '', ID_CK = cookieGet('hzai_did') || '';
  var DEVICE = ID_LS || ID_CK || ('d' + rid());
  if (!ID_LS) lsSet('hzai_device', DEVICE);
  if (!ID_CK) cookieSet('hzai_did', DEVICE);
  /* a first visit (both empty) is not a cleared one: it reports the new id in both, or the backend reads
     every new customer as suspicious and allows 1 preview a day instead of 5 */
  if (!ID_LS && !ID_CK) ID_LS = ID_CK = DEVICE;
  var SESSION = (function () { var v = ''; try { v = sessionStorage.getItem('hzai_sid') || ''; if (!v) { v = 's' + rid(); sessionStorage.setItem('hzai_sid', v); } } catch (e) {} return v; })();
  var STARTS_KEY = 'hzai_starts_' + DAY, PH_KEY = 'hzai_ph_' + DAY, LAST_KEY = 'hzai_last_start', BLOCK_KEY = 'hzai_block_until';
  function phCounts() { try { return JSON.parse(lsGet(PH_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function phBump(ph) { if (!ph) return; var m = phCounts(), ks; m[ph] = (m[ph] || 0) + 1; ks = Object.keys(m); if (ks.length > 60) delete m[ks[0]]; lsSet(PH_KEY, JSON.stringify(m)); }
  /* SHA-256 of the photo, so the same photo sent again is seen as the same */
  function hashFile(f) {
    if (!window.crypto || !crypto.subtle || !f.arrayBuffer) return Promise.resolve('');
    return f.arrayBuffer().then(function (b) { return crypto.subtle.digest('SHA-256', b); }).then(function (d) {
      return Array.prototype.map.call(new Uint8Array(d).slice(0, 16), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    }).catch(function () { return ''; });
  }
  /* a short sync hash, so an instruction (up to 1000 characters) can join the photo hash as a key */
  function h32(s) { var h = 0x811c9dc5; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; } return h.toString(36); }
  /* rk: the photo + instruction key. A customer may send one photo again with new wishes; only the same
     photo with the same wishes counts as a repeat (rp) */
  function signals(ph, rk) {
    var last = +(lsGet(LAST_KEY) || 0);
    rk = rk || ph;
    var o = {
      v: 1,
      d: ID_LS, k: ID_CK, s: SESSION,              /* device id in localStorage / cookie (as found on load), tab session */
      n: STARTED, nd: +(lsGet(STARTS_KEY) || 0),    /* previews started in this tab / on this device today */
      t: Date.now() - T_LOAD,                       /* ms from page load to this start */
      dt: last ? Date.now() - last : null,          /* ms since this device's previous start */
      ui: UI_EVENTS,                                /* real taps / clicks / keys on the page so far */
      ph: ph || '', rp: rk ? (phCounts()[rk] || 0) : 0,   /* photo hash; times this photo was sent today with this instruction */
      tz: new Date().getTimezoneOffset(), sw: screen.width, sh: screen.height, tp: navigator.maxTouchPoints || 0
    };
    if (C.cust) o.c = C.cust;                       /* logged-in customer, signed by Liquid with the shared secret */
    return o;
  }
  function b64url(o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function blockedMinutes() { var u = +(lsGet(BLOCK_KEY) || 0); return u > Date.now() ? Math.ceil((u - Date.now()) / 60000) : 0; }

  /* ======================================================================
     mockup engine (all scenes drawn in a 1000-unit square)
     ====================================================================== */
  function cover(x, img, W, H) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, s = Math.max(W / iw, H / ih);
    x.drawImage(img, (W - iw * s) / 2, (H - ih * s) / 2, iw * s, ih * s);
  }
  var POSTERS = {}, POSTER_SRC = null;
  /* full-bleed art at any ratio: the canvas face, the mug wrap */
  function poster(ratio) {
    var im = curImg();
    if (POSTER_SRC !== im) { for (var k in POSTERS) free(POSTERS[k]); POSTERS = {}; POSTER_SRC = im; }
    var rk = ratio.toFixed(3);
    if (!POSTERS[rk]) { var W = 900, H = Math.round(W / ratio), c = mk(W, H); if (im) cover(hq(c), im, W, H); POSTERS[rk] = c; }
    return POSTERS[rk];
  }
  function scaleOf(x) { try { return x.getTransform().a; } catch (e) { return 1; } }
  /* soft shape = its shadow only: draw far off-canvas, throw the shadow back (works without ctx.filter) */
  function blurFill(x, path, col, blur, dx, dy) {
    var k = scaleOf(x); x.save(); x.translate(-3000, 0);
    x.shadowColor = col; x.shadowBlur = blur * Math.abs(k); x.shadowOffsetX = 3000 * k + (dx || 0) * k; x.shadowOffsetY = (dy || 0) * Math.abs(k);
    x.fillStyle = '#000'; path(x); x.fill(); x.restore();
  }
  function blurStroke(x, pts, col, w, bl) {
    var k = scaleOf(x); x.save(); x.translate(-3000, 0);
    x.shadowColor = col; x.shadowBlur = bl * Math.abs(k); x.shadowOffsetX = 3000 * k;
    x.strokeStyle = '#000'; x.lineWidth = w; x.lineCap = 'round';
    x.beginPath(); x.moveTo(pts[0][0], pts[0][1]); x.quadraticCurveTo(pts[1][0], pts[1][1], pts[2][0], pts[2][1]); x.stroke(); x.restore();
  }
  function noiseTile() {
    if (noiseTile.c) return noiseTile.c;
    var c = mk(160, 160), x = c.getContext('2d'), r = rng(7);
    for (var i = 0; i < 2600; i++) { var v = r() < .5 ? 0 : 255; x.fillStyle = 'rgba(' + v + ',' + v + ',' + v + ',' + (r() * .5).toFixed(2) + ')'; x.fillRect(r() * 160, r() * 160, 1 + r() * 1.5, 1 + r() * 1.5); }
    return (noiseTile.c = c);
  }
  function studio(x) {
    var g = x.createLinearGradient(0, 0, 0, 1000); g.addColorStop(0, '#F6F4EE'); g.addColorStop(1, '#E8E5EE'); x.fillStyle = g; x.fillRect(0, 0, 1000, 1000);
    var r = x.createRadialGradient(500, 420, 40, 500, 500, 760); r.addColorStop(0, 'rgba(255,255,255,.8)'); r.addColorStop(1, 'rgba(255,255,255,0)'); x.fillStyle = r; x.fillRect(0, 0, 1000, 1000);
  }
  function label(x, t, cx, y, size, col) { x.save(); x.font = '700 ' + size + 'px Roboto, system-ui, sans-serif'; x.textAlign = 'center'; x.fillStyle = col || '#262550'; x.fillText(t, cx, y); x.restore(); }

  /* ---------- matching tee (add-on) ---------- */
  function teePath(x) {
    x.beginPath();
    x.moveTo(408, 118); x.quadraticCurveTo(334, 124, 262, 150); x.lineTo(118, 292); x.lineTo(196, 366);
    x.quadraticCurveTo(232, 338, 262, 326); x.quadraticCurveTo(254, 610, 266, 880); x.quadraticCurveTo(500, 898, 734, 880);
    x.quadraticCurveTo(746, 610, 738, 326); x.quadraticCurveTo(768, 338, 804, 366); x.lineTo(882, 292); x.lineTo(738, 150);
    x.quadraticCurveTo(666, 124, 592, 118); x.quadraticCurveTo(500, 236, 408, 118); x.closePath();
  }
  var FOLDS = [
    { p: [[270, 340], [330, 420], [392, 470]], w: 26, a: .16 }, { p: [[730, 340], [670, 420], [608, 470]], w: 26, a: .16 },
    { p: [[360, 640], [352, 760], [364, 870]], w: 40, a: .08 }, { p: [[640, 620], [652, 760], [640, 870]], w: 40, a: .08 },
    { p: [[250, 190], [210, 250], [176, 300]], w: 18, a: .12 }, { p: [[750, 190], [790, 250], [824, 300]], w: 18, a: .12 },
    { p: [[430, 196], [500, 220], [570, 196]], w: 16, a: .10 }
  ];
  var HILITES = [{ p: [[292, 372], [326, 432], [344, 500]], w: 26, a: .07 }, { p: [[708, 372], [674, 432], [656, 500]], w: 26, a: .07 }];
  var TEE_BLACK = { hex: '#1c1c21', dark: true };
  function teeObj(x, a, c) {
    blurFill(x, teePath, 'rgba(38,37,80,.26)', 30, 0, 16);
    x.save();
    teePath(x); x.fillStyle = c.hex; x.fill(); x.clip();
    x.beginPath(); x.moveTo(408, 118); x.quadraticCurveTo(500, 138, 592, 118); x.quadraticCurveTo(500, 236, 408, 118); x.closePath();
    x.fillStyle = shade(c.hex, .7); x.fill();
    var pw = 368, ph = pw * a.height / a.width, px = 500 - pw / 2, py = 196;
    x.globalAlpha = .96; x.drawImage(a, px, py, pw, ph); x.globalAlpha = 1;
    x.save(); x.globalCompositeOperation = 'multiply';
    var g = x.createLinearGradient(118, 0, 882, 0);
    g.addColorStop(0, 'rgba(0,0,0,.24)'); g.addColorStop(.18, 'rgba(0,0,0,.06)'); g.addColorStop(.5, 'rgba(0,0,0,0)'); g.addColorStop(.82, 'rgba(0,0,0,.06)'); g.addColorStop(1, 'rgba(0,0,0,.24)');
    x.fillStyle = g; x.fillRect(100, 100, 800, 820);
    FOLDS.forEach(function (f) { blurStroke(x, f.p, 'rgba(0,0,0,' + (f.a * 1.4).toFixed(3) + ')', f.w, 18); });
    x.globalCompositeOperation = 'screen';
    HILITES.forEach(function (f) { blurStroke(x, f.p, 'rgba(255,255,255,' + (f.a * .8).toFixed(3) + ')', f.w, 22); });
    x.restore();
    x.lineCap = 'round';
    x.beginPath(); x.moveTo(408, 118); x.quadraticCurveTo(500, 236, 592, 118); x.strokeStyle = shade(c.hex, 1.12); x.lineWidth = 20; x.stroke();
    x.beginPath(); x.moveTo(408, 118); x.quadraticCurveTo(500, 138, 592, 118); x.strokeStyle = shade(c.hex, 1.08); x.lineWidth = 8; x.stroke();
    x.globalAlpha = .06; x.globalCompositeOperation = 'overlay'; x.fillStyle = x.createPattern(noiseTile(), 'repeat'); x.fillRect(0, 0, 1000, 1000);
    x.restore();
  }
  /* ---------- matching mug (add-on) ---------- */
  function mugHandle(x, cx, R, top, bot, side) {
    var H = bot - top, ax = cx + side * (R - 10), y1 = top + H * .2, y2 = top + H * .72;
    function hp() { x.beginPath(); x.moveTo(ax, y1); x.bezierCurveTo(cx + side * (R + 150), y1 - 24, cx + side * (R + 165), y2 + 34, ax, y2); }
    x.save(); x.lineCap = 'round';
    x.save(); x.translate(side * 8, 12); x.lineWidth = 46; x.strokeStyle = 'rgba(38,37,80,.14)'; hp(); x.stroke(); x.restore();
    x.lineWidth = 44; x.strokeStyle = '#d9d9d4'; hp(); x.stroke();
    x.lineWidth = 34; x.strokeStyle = '#f3f3f0'; hp(); x.stroke();
    x.save(); x.translate(-side * 7, -5); x.lineWidth = 9; x.strokeStyle = 'rgba(255,255,255,.95)'; hp(); x.stroke(); x.restore();
    x.restore();
  }
  function gloss(x, hx, hw, top, h, a) {
    var g = x.createLinearGradient(hx - hw, 0, hx + hw, 0);
    g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(.5, 'rgba(255,255,255,' + a + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
    x.fillStyle = g; x.fillRect(hx - hw, top, hw * 2, h);
  }
  var MUG_WRAP = 3.5;
  function mugGeo(big) { return { R: big ? 208 : 200, top: big ? 190 : 290, bot: 790, ry: 38 }; }
  function mugRatio(big) { var g = mugGeo(big); return g.R * MUG_WRAP / ((g.bot - g.top) * .86); }
  function mugObj(x, big, side) {
    var G = mugGeo(big), R = G.R, bot = G.bot, top = G.top, ry = G.ry, cx = 500 - side * 42, H = bot - top, a = poster(mugRatio(big));
    blurFill(x, function (x) { x.beginPath(); x.ellipse(cx + side * 24, bot + 6, R * 1.16, 28, 0, 0, 6.2832); }, 'rgba(38,37,80,.30)', 24, 0, 4);
    mugHandle(x, cx, R, top, bot, side);
    x.save();
    x.beginPath(); x.moveTo(cx - R, top); x.lineTo(cx - R, bot); x.ellipse(cx, bot, R, ry, 0, Math.PI, 0, true); x.lineTo(cx + R, top); x.ellipse(cx, top, R, ry, 0, 0, Math.PI, false); x.closePath();
    x.fillStyle = '#f7f7f4'; x.fill(); x.clip();
    /* the print wraps round the cylinder, one DEVICE pixel column at a time (no seams) */
    var k = Math.abs(scaleOf(x)), m0 = H * .07, ph = H - 2 * m0, tp = MUG_WRAP / 2,
        W2 = Math.max(2, Math.round(2 * R * k)), H2 = Math.max(2, Math.round((ph + ry) * k)), wc = mk(W2, H2), wx = hq(wc);
    for (var dx = 0; dx < W2; dx++) {
      var nx = (dx + .5) / W2 * 2 - 1, t = Math.asin(nx), u = (t + tp) / (2 * tp),
          sw = Math.max(.5, a.width / (2 * tp) * (2 / W2) / Math.sqrt(Math.max(1e-4, 1 - nx * nx))), sx = clamp(u * a.width - sw / 2, 0, a.width - sw);
      wx.drawImage(a, sx, 0, sw, a.height, dx, ry * Math.cos(t) * k, 1, ph * k);
    }
    x.drawImage(wc, cx - R, top + m0, 2 * R, ph + ry); free(wc);
    x.globalCompositeOperation = 'multiply';
    var g = x.createLinearGradient(cx - R, 0, cx + R, 0);
    g.addColorStop(0, 'rgba(30,30,50,.46)'); g.addColorStop(.08, 'rgba(30,30,50,.2)'); g.addColorStop(.26, 'rgba(30,30,50,0)');
    g.addColorStop(.6, 'rgba(30,30,50,.03)'); g.addColorStop(.86, 'rgba(30,30,50,.2)'); g.addColorStop(1, 'rgba(30,30,50,.5)');
    x.fillStyle = g; x.fillRect(cx - R, top - ry, 2 * R, H + 2 * ry + 2);
    x.globalCompositeOperation = 'screen';
    gloss(x, cx - R * .5, R * .13, top, H + ry, .6); gloss(x, cx + R * .66, R * .05, top, H + ry, .28);
    x.restore();
    x.save();
    x.beginPath(); x.ellipse(cx, top, R, ry, 0, 0, 6.2832); x.fillStyle = '#fafaf8'; x.fill();
    x.beginPath(); x.ellipse(cx, top + 1.5, R - 12, ry - 5, 0, 0, 6.2832);
    var ig = x.createLinearGradient(0, top - ry, 0, top + ry); ig.addColorStop(0, '#c9c9c6'); ig.addColorStop(.5, '#dededb'); ig.addColorStop(1, '#efefec'); x.fillStyle = ig; x.fill();
    x.lineWidth = 1.5; x.strokeStyle = 'rgba(0,0,0,.10)'; x.beginPath(); x.ellipse(cx, top, R, ry, 0, 0, 6.2832); x.stroke();
    x.restore();
  }
  function tabletop(x) { var g = x.createLinearGradient(0, 640, 0, 1000); g.addColorStop(0, 'rgba(38,37,80,0)'); g.addColorStop(1, 'rgba(38,37,80,.07)'); x.fillStyle = g; x.fillRect(0, 640, 1000, 360); }

  /* ---------- room pieces ---------- */
  function wall(x) {
    var g = x.createLinearGradient(0, 0, 0, 1000); g.addColorStop(0, '#EFEAE1'); g.addColorStop(1, '#E3DDD2'); x.fillStyle = g; x.fillRect(0, 0, 1000, 1000);
    var r = x.createRadialGradient(200, 80, 20, 260, 160, 950); r.addColorStop(0, 'rgba(255,255,255,.6)'); r.addColorStop(1, 'rgba(255,255,255,0)'); x.fillStyle = r; x.fillRect(0, 0, 1000, 1000);
  }
  function rr(x, X, Y, W, H, R, fill) { x.beginPath(); x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R); x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath(); x.fillStyle = fill; x.fill(); }
  function sofa(x, cx, fy, w) {
    var h = 300, L = cx - w / 2, T = fy - h, col = '#8e97a8';
    blurFill(x, function (x) { x.beginPath(); x.ellipse(cx, fy, w * .52, 22, 0, 0, 6.2832); }, 'rgba(40,30,20,.35)', 20, 0, 2);
    x.fillStyle = '#5b4a36'; x.fillRect(L + 40, fy - 30, 14, 30); x.fillRect(L + w - 54, fy - 30, 14, 30);
    rr(x, L + 20, T, w - 40, 170, 26, shade(col, .9));
    rr(x, L + 60, T + 140, w - 120, 110, 16, shade(col, .74));
    rr(x, L + 80, T + 30, (w - 160) / 2 - 6, 130, 22, shade(col, 1.07)); rr(x, cx + 6, T + 30, (w - 160) / 2 - 6, 130, 22, shade(col, 1.07));
    rr(x, L + 10, T + 220, w - 20, 52, 14, shade(col, .8));
    rr(x, L + 70, T + 150, (w - 140) / 2 - 4, 86, 18, col); rr(x, cx + 2, T + 150, (w - 140) / 2 - 4, 86, 18, col);
    rr(x, L, T + 104, 92, h - 134, 24, shade(col, .85)); rr(x, L + w - 92, T + 104, 92, h - 134, 24, shade(col, .85));
  }

  /* ---------- the frames: the client's photos, 9-sliced so the mitred corners keep their shape ---------- */
  var FRAME_RING = {
    black: { src: C.rings && C.rings.black, b: [77, 73, 78, 74] },
    wood: { src: C.rings && C.rings.wood, b: [84, 80, 87, 84] },
    white: { src: C.rings && C.rings.white, b: [72, 70, 71, 72] }
  };
  /* [face, side] colours sampled from those photos: the face stands in until a photo loads */
  var FRAME_SIDE = { black: ['#363737', '#1f2021'], wood: ['#b47e55', '#8a5c3a'], white: ['#e5e5e5', '#cbc9c4'] };
  var FRAME_FACE = .9, FRAME_GAP = .3;   /* inches */
  function ring(x, fr, L, T, W, H, t) {
    var R = FRAME_RING[fr], im = R && R.img;
    if (!im) {
      x.save(); x.beginPath(); x.rect(L, T, W, H); x.rect(L + t, T + t, W - 2 * t, H - 2 * t);
      x.fillStyle = (FRAME_SIDE[fr] || ['#555'])[0]; x.fill('evenodd'); x.restore(); return;
    }
    var b = R.b, iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height, k = t / Math.max(b[0], b[1], b[2], b[3]),
        l = b[0] * k, tp = b[1] * k, r = b[2] * k, bt = b[3] * k, o = .6, mw = iw - b[0] - b[2], mh = ih - b[1] - b[3];
    /* sides first, a hair longer, then the corners over their ends: no seams between the pieces */
    x.drawImage(im, b[0], 0, mw, b[1], L + l - o, T, W - l - r + 2 * o, tp);
    x.drawImage(im, b[0], ih - b[3], mw, b[3], L + l - o, T + H - bt, W - l - r + 2 * o, bt);
    x.drawImage(im, 0, b[1], b[0], mh, L, T + tp - o, l, H - tp - bt + 2 * o);
    x.drawImage(im, iw - b[2], b[1], b[2], mh, L + W - r, T + tp - o, r, H - tp - bt + 2 * o);
    x.drawImage(im, 0, 0, b[0], b[1], L, T, l, tp);
    x.drawImage(im, iw - b[2], 0, b[2], b[1], L + W - r, T, r, tp);
    x.drawImage(im, 0, ih - b[3], b[0], b[3], L, T + H - bt, l, bt);
    x.drawImage(im, iw - b[2], ih - b[3], b[2], b[3], L + W - r, T + H - bt, r, bt);
  }
  /* the dark recess a floating canvas hovers over */
  function gapFill(x, L, T, W, H) { var g = x.createLinearGradient(L, T, L + W, T + H); g.addColorStop(0, '#2b2931'); g.addColorStop(1, '#0e0d12'); x.fillStyle = g; x.fillRect(L, T, W, H); }

  /* ---------- the canvas itself ---------- */
  function weaveTile() {
    if (weaveTile.c) return weaveTile.c;
    var c = mk(6, 6), x = c.getContext('2d');
    x.fillStyle = 'rgba(255,255,255,.55)'; x.fillRect(0, 0, 6, 1); x.fillRect(0, 3, 6, 1);
    x.fillStyle = 'rgba(0,0,0,.45)'; x.fillRect(0, 0, 1, 6); x.fillRect(3, 0, 1, 6);
    return (weaveTile.c = c);
  }
  function canvasWeave(x, X, Y, W, H, a) { x.save(); x.globalAlpha = a; x.globalCompositeOperation = 'overlay'; x.fillStyle = x.createPattern(weaveTile(), 'repeat'); x.fillRect(X, Y, W, H); x.restore(); }
  /* the canvas rolls over its stretcher bars: a soft dark band right/bottom, a light one top/left */
  function wrapShade(x, X, Y, W, H, e) {
    var g;
    g = x.createLinearGradient(X + W - e * 3, 0, X + W, 0); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,.3)'); x.fillStyle = g; x.fillRect(X + W - e * 3, Y, e * 3, H);
    g = x.createLinearGradient(0, Y + H - e * 3, 0, Y + H); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,.26)'); x.fillStyle = g; x.fillRect(X, Y + H - e * 3, W, e * 3);
    g = x.createLinearGradient(X, 0, X + e * 2, 0); g.addColorStop(0, 'rgba(255,255,255,.18)'); g.addColorStop(1, 'rgba(255,255,255,0)'); x.fillStyle = g; x.fillRect(X, Y, e * 2, H);
    g = x.createLinearGradient(0, Y, 0, Y + e * 2); g.addColorStop(0, 'rgba(255,255,255,.16)'); g.addColorStop(1, 'rgba(255,255,255,0)'); x.fillStyle = g; x.fillRect(X, Y, W, e * 2);
  }
  /* front view. aw x ah = the painted face; u = scene units per inch (sets frame, gap and the 1.25" depth) */
  function canvasObj(x, cx, cy, aw, ah, fr, u, tex) {
    var framed = !!fr, gap = framed ? FRAME_GAP * u : 0, fw = framed ? FRAME_FACE * u : 0, W = aw + 2 * (gap + fw), H = ah + 2 * (gap + fw), L = cx - W / 2, T = cy - H / 2, d = 1.25 * u;
    function box(x) { x.beginPath(); x.rect(L, T, W, H); }
    blurFill(x, box, 'rgba(50,38,20,.30)', Math.max(6, d * 1.1), d * .35, d * .55);
    blurFill(x, box, 'rgba(40,30,16,.30)', Math.max(3, d * .3), d * .1, d * .18);
    if (framed) gapFill(x, L + fw / 2, T + fw / 2, W - fw, H - fw);
    var ax = cx - aw / 2, ay = cy - ah / 2;
    x.drawImage(tex || poster(aw / ah), ax, ay, aw, ah);
    wrapShade(x, ax, ay, aw, ah, clamp(u * .12, 1.2, 5));
    canvasWeave(x, ax, ay, aw, ah, .07);
    if (framed) ring(x, fr, L, T, W, H, fw);
  }
  /* view 1 · the painting alone on the wall, as big as the frame allows */
  function sceneWall(x, o) {
    wall(x);
    var lg = x.createLinearGradient(0, 0, 900, 900); lg.addColorStop(0, 'rgba(255,255,255,.3)'); lg.addColorStop(.55, 'rgba(255,255,255,0)'); x.fillStyle = lg; x.fillRect(0, 0, 1000, 1000);
    var s = o.size, ah = 860 / (1 + (o.ring ? 2.4 / s.h : 0)), u = ah / s.h;
    canvasObj(x, 500, 510, s.w * u, ah, o.ring, u);
  }
  /* view 2 · three-quarter close-up: the 1.25" depth and the mirrored wrap round the edge,
     built one DEVICE pixel column at a time (Canvas 2D has no perspective transform) */
  function frontOf(tex, fr, Wo, Ho, fw, gp) {
    var k = tex.height / (Ho - 2 * (fw + gp)), c = mk(Wo * k, Ho * k), x = hq(c), W = c.width, H = c.height, i = (fw + gp) * k;
    gapFill(x, 0, 0, W, H); x.drawImage(tex, i, i, W - 2 * i, H - 2 * i); ring(x, fr, 0, 0, W, H, fw * k);
    return c;
  }
  function sceneAngle(x, o) {
    studio(x); tabletop(x);
    var s = o.size, fr = o.ring, framed = !!fr, r = s.w / s.h, inch = 1 / s.h,
        W3 = r, H3 = 1, D3 = 1.25 * inch, fw3 = framed ? FRAME_FACE * inch : 0, gp3 = framed ? FRAME_GAP * inch : 0,
        Wo = W3 + 2 * (fw3 + gp3), Ho = H3 + 2 * (fw3 + gp3), Do = framed ? D3 + .3 * inch : D3;
    var hr = 740, hl = hr * .78, hb = hr * .975, cy = 480,
        wf = Wo / Ho * (hl + hr) / 2 * .8, ws = Math.max(10, Do / Ho * hr * .7), tw = wf + ws, xl = 480 - tw / 2, xr = xl + wf;
    function sil(x) { x.beginPath(); x.moveTo(xl, cy - hl / 2); x.lineTo(xr, cy - hr / 2); x.lineTo(xr + ws, cy - hb / 2); x.lineTo(xr + ws, cy + hb / 2); x.lineTo(xr, cy + hr / 2); x.lineTo(xl, cy + hl / 2); x.closePath(); }
    blurFill(x, sil, 'rgba(50,38,20,.30)', 50, 40, 26);
    blurFill(x, function (x) { x.beginPath(); x.ellipse(xl + tw * .55, cy + hr / 2 + 8, tw * .55, 16, 0, 0, 6.2832); }, 'rgba(38,37,80,.28)', 22, 0, 0);
    var k = Math.abs(scaleOf(x)), nf = Math.max(2, Math.round(wf * k)), ns = Math.max(1, Math.round(ws * k)), H2 = Math.max(2, Math.round(hr * k)),
        oc = mk(nf + ns, H2), ox = hq(oc), tex = poster(r), TW = tex.width, TH = tex.height, fc = FRAME_SIDE[fr], dx, t, h, u0, u1, top,
        face = framed ? frontOf(tex, fr, Wo, Ho, fw3, gp3) : tex, FW = face.width, FH = face.height;
    function U(t) { return t * hr / ((1 - t) * hl + t * hr); }
    for (dx = 0; dx < nf; dx++) {
      t = (dx + .5) / nf; h = (hl + (hr - hl) * t) * k; u0 = U(dx / nf); u1 = U((dx + 1) / nf); top = (H2 - h) / 2;
      var sw = Math.max(.5, (u1 - u0) * FW), sx = Math.min(u0 * FW, FW - sw);
      ox.drawImage(face, sx, 0, sw, FH, dx, top, 1, h);
    }
    if (framed) free(face);
    for (var ds = 0; ds < ns; ds++) {
      var sm = (ds + .5) / ns, h2 = (hr + (hb - hr) * sm) * k, top2 = (H2 - h2) / 2;
      if (framed) { ox.fillStyle = fc[1]; ox.fillRect(nf + ds, top2, 1, h2); }
      else {
        var a1 = (1 - (ds / ns) * D3 / W3) * TW, a0 = (1 - ((ds + 1) / ns) * D3 / W3) * TW;
        ox.drawImage(tex, a0, 0, Math.max(.5, a1 - a0), TH, nf + ds, top2, 1, h2);
      }
    }
    x.drawImage(oc, xl, cy - hr / 2, tw, hr); free(oc);
    x.save();
    x.beginPath(); x.moveTo(xr, cy - hr / 2); x.lineTo(xr + ws, cy - hb / 2); x.lineTo(xr + ws, cy + hb / 2); x.lineTo(xr, cy + hr / 2); x.closePath();
    x.fillStyle = 'rgba(0,0,0,' + (framed ? .2 : .34) + ')'; x.fill();
    x.beginPath(); x.moveTo(xl, cy - hl / 2); x.lineTo(xr, cy - hr / 2); x.lineTo(xr, cy + hr / 2); x.lineTo(xl, cy + hl / 2); x.closePath(); x.clip();
    var fg = x.createLinearGradient(xl, 0, xr, 0); fg.addColorStop(0, 'rgba(255,255,255,.08)'); fg.addColorStop(1, 'rgba(0,0,0,.05)'); x.fillStyle = fg; x.fillRect(xl, cy - hr / 2, wf, hr);
    canvasWeave(x, xl, cy - hr / 2, wf, hr, framed ? .05 : .09);
    x.restore();
    x.save(); x.strokeStyle = 'rgba(255,255,255,.4)'; x.lineWidth = 2; x.beginPath(); x.moveTo(xr, cy - hr / 2 + 1); x.lineTo(xr, cy + hr / 2 - 1); x.stroke(); x.restore();
  }
  /* view 3 · every size to scale over an 84" sofa, the chosen one marked */
  function sceneSizes(x, o) {
    wall(x);
    var fl = x.createLinearGradient(0, 880, 0, 1000); fl.addColorStop(0, '#c9b89c'); fl.addColorStop(1, '#b9a585'); x.fillStyle = fl; x.fillRect(0, 880, 1000, 120);
    sofa(x, 500, 882, 720);
    var tot = 0, maxH = 0, gapIn = 4, padIn = o.ring ? 1.2 : 0;
    SIZES.forEach(function (s) { tot += s.w + 2 * padIn; maxH = Math.max(maxH, s.h + 2 * padIn); });
    tot += gapIn * (SIZES.length - 1);
    /* 84" sofa = 720 units; shrink only if the row would not fit the wall */
    var ppi = Math.min(720 / 84, 900 / tot, 520 / maxH), pad = padIn * ppi, gap = gapIn * ppi, cy = 388, x0 = 500 - tot * ppi / 2;
    SIZES.forEach(function (s) {
      var aw = s.w * ppi, ah = s.h * ppi, W = aw + 2 * pad, cx = x0 + W / 2, on = s.id === o.size.id, ly = cy + ah / 2 + pad + 36;
      canvasObj(x, cx, cy, aw, ah, o.ring, ppi);
      x.save(); x.font = '700 ' + (on ? 25 : 22) + 'px Roboto, system-ui, sans-serif'; x.textAlign = 'center'; x.fillStyle = on ? '#262550' : '#7c7994'; x.fillText(s.name, cx, ly);
      if (on) { var w = x.measureText(s.name).width; x.fillStyle = '#262550'; x.fillRect(cx - w / 2, ly + 8, w, 4); }
      x.restore();
      x0 += W + gap;
    });
    label(x, 'Shown to scale over an 84" sofa', 500, 150, 24, '#4b4874');
  }
  function roundClip(x, X, Y, W, H, R) { x.beginPath(); x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R); x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath(); }
  /* view 4 · the customer's photo next to the art */
  function sceneBA(x) {
    studio(x);
    var cv = curVer(), p = (cv && cv.photo) || S.photo, art = curImg(); if (!p || !art) return;
    /* the art whole and big (its own shape, nothing cut), the photo small beside it */
    var r = (art.naturalWidth || art.width) / (art.naturalHeight || art.height), HA = 780, WA = HA * r;
    if (WA > 600) { WA = 600; HA = WA / r; }
    var XA = 1000 - 56 - WA, YA = (1000 - HA) / 2 + 22, WP = 230, HP = 288, XP = 56, YP = YA + (HA - HP) / 2, ax = (XP + WP + XA) / 2, ay = YA + HA / 2;
    blurFill(x, function (x) { roundClip(x, XP, YP, WP, HP, 16); }, 'rgba(38,37,80,.3)', 26, 0, 12);
    blurFill(x, function (x) { roundClip(x, XA, YA, WA, HA, 18); }, 'rgba(38,37,80,.3)', 30, 0, 14);
    x.save(); roundClip(x, XP, YP, WP, HP, 16); x.clip(); x.fillStyle = '#ddd'; x.fillRect(XP, YP, WP, HP); x.translate(XP, YP); cover(x, p.canvas, WP, HP); x.restore();
    x.save(); roundClip(x, XA, YA, WA, HA, 18); x.clip(); x.drawImage(art, XA, YA, WA, HA); x.restore();
    x.save(); x.beginPath(); x.arc(ax, ay, 34, 0, 6.2832); x.fillStyle = '#fff'; x.shadowColor = 'rgba(38,37,80,.3)'; x.shadowBlur = 16 * scaleOf(x); x.fill(); x.restore();
    x.save(); x.strokeStyle = '#9A7B3A'; x.lineWidth = 5; x.lineCap = 'round'; x.lineJoin = 'round'; x.beginPath(); x.moveTo(ax - 15, ay); x.lineTo(ax + 14, ay); x.moveTo(ax + 2, ay - 12); x.lineTo(ax + 15, ay); x.lineTo(ax + 2, ay + 12); x.stroke(); x.restore();
    label(x, 'YOUR PHOTO', XP + WP / 2, YP - 22, 22, '#7c7994'); label(x, 'AI ART', XA + WA / 2, YA - 24, 26, '#9A7B3A');
  }
  /* view 5 · the photo guide */
  var GUIDE = null;
  function sceneGuide(x) {
    studio(x); if (!GUIDE) return;
    var gw = GUIDE.naturalWidth, gh = GUIDE.naturalHeight, s = Math.min(780 / gw, 780 / gh), w = gw * s, h = gh * s;
    blurFill(x, function (x) { x.beginPath(); x.rect(500 - w / 2, 500 - h / 2, w, h); }, 'rgba(38,37,80,.25)', 30, 0, 14);
    x.drawImage(GUIDE, 500 - w / 2, 500 - h / 2, w, h);
  }
  function begin(cv) {
    var x = cv.getContext('2d'), k = cv.width / 1000;
    x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, cv.width, cv.height);
    if (!curImg()) { x.fillStyle = '#EAE5DA'; x.fillRect(0, 0, cv.width, cv.height); return null; }
    x.setTransform(k, 0, 0, k, 0, 0); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    return x;
  }
  function look() { return { size: sizeOf(S.size), ring: S.digitalOnly ? null : frameOf(S.frame).ring }; }
  function drawView(cv, i) {
    var x = begin(cv); if (!x) return;
    var o = look();
    if (i === 1) sceneAngle(x, o);
    else if (i === 2) sceneSizes(x, o);
    else if (i === 3) sceneBA(x);
    else if (i === 4) sceneGuide(x);
    else sceneWall(x, o);
    x.setTransform(1, 0, 0, 1, 0, 0);
  }
  function drawTee(cv) { var x = begin(cv); if (!x) return; studio(x); teeObj(x, curImg(), TEE_BLACK); x.setTransform(1, 0, 0, 1, 0, 0); }
  function drawMug(cv, big) { var x = begin(cv); if (!x) return; studio(x); tabletop(x); mugObj(x, big, 1); x.setTransform(1, 0, 0, 1, 0, 0); }
  /* ----------------------------------------------------------------------
     the wait, made visible on the stage (1000 units), one step per line of the progress card:
     1) the customer's photo as it is; 2) a gold line sweeps down and cuts the background away (a person
     mask from MediaPipe's selfie segmenter, fetched from jsDelivr when the photo comes in; a soft oval
     when there is no person in it, or the model fails or is slow); 3) the subject turns dreamy, slowly,
     until the art comes back. Only a show: the backend paints from the original photo
     ---------------------------------------------------------------------- */
  var SEG_CDN = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  var SEG_MODEL = 'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite';
  var DREAM = ['#2b1d5e', '#8a5cd6', '#f29ccb', '#ffd98a', '#fff7e8'];   /* gradient map for the dreamy look, dark to light */
  var FX_BG = ['#1c1842', '#4a2f7a'];
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var segP = null;
  function segmenter() {
    if (segP) return segP;
    segP = new Promise(function (res, rej) {
      var imp; try { imp = new Function('u', 'return import(u)'); } catch (e) { rej(e); return; }
      imp(SEG_CDN + '/vision_bundle.mjs').then(function (m) {
        return m.FilesetResolver.forVisionTasks(SEG_CDN + '/wasm').then(function (fs) {
          return m.ImageSegmenter.createFromOptions(fs, { baseOptions: { modelAssetPath: SEG_MODEL }, runningMode: 'IMAGE', outputConfidenceMasks: true, outputCategoryMask: false });
        });
      }).then(res, rej);
    });
    segP.catch(function () {});
    return segP;
  }
  function ovalMask(w, h) {
    var c = mk(w, h), x = c.getContext('2d'), g;
    x.translate(w / 2, h * .47); x.scale(w * .38, h * .46);
    g = x.createRadialGradient(0, 0, .6, 0, 0, 1); g.addColorStop(0, '#000'); g.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g; x.beginPath(); x.arc(0, 0, 1, 0, Math.PI * 2); x.fill();
    return c;
  }
  /* the mask of a photo canvas (kept on it, so the one worked out on upload is reused) */
  function maskFor(cvs) {
    if (cvs.hzMask) return cvs.hzMask;
    var k = Math.min(1, 320 / Math.max(cvs.width, cvs.height)), w = Math.max(1, Math.round(cvs.width * k)), h = Math.max(1, Math.round(cvs.height * k));
    var small = mk(w, h); hq(small).drawImage(cvs, 0, 0, w, h);
    var real = segmenter().then(function (sg) {
      var r = sg.segment(small), cm = r && r.confidenceMasks && r.confidenceMasks[0];
      if (!cm) throw new Error('mask');
      var a = cm.getAsFloat32Array(), mw = cm.width, mh = cm.height, i, xx, yy, v, tot = 0, edge = 0, ne = 0, on = 0;
      for (i = 0; i < a.length; i++) { tot += a[i]; xx = i % mw; yy = (i / mw) | 0; if (xx < 3 || yy < 3 || xx >= mw - 3) { edge += a[i]; ne++; } }
      var inv = ne > 0 && edge / ne > tot / a.length;   /* the person is the part away from the top and the sides */
      var c = mk(mw, mh), x = c.getContext('2d'), d = x.createImageData(mw, mh);
      for (i = 0; i < a.length; i++) { v = inv ? 1 - a[i] : a[i]; v = v < .3 ? 0 : v > .7 ? 1 : (v - .3) / .4; on += v; d.data[i * 4 + 3] = v * 255; }
      try { cm.close(); if (r.close) r.close(); } catch (e) {}
      free(small);
      if (on / a.length < .04) throw new Error('no person');
      x.putImageData(d, 0, 0); return c;
    });
    cvs.hzMask = Promise.race([real, new Promise(function (res, rej) { setTimeout(function () { rej(new Error('slow')); }, 6000); })])
      .catch(function () { return ovalMask(w, h); });
    return cvs.hzMask;
  }
  function gradLut(cols) {
    var lut = [], i, t, a, b, f, n = cols.length - 1, rgb = cols.map(function (h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; });
    for (i = 0; i < 256; i++) { t = i / 255 * n; a = Math.min(n - 1, Math.floor(t)); f = t - a; b = a + 1; lut.push(rgb[a][0] + (rgb[b][0] - rgb[a][0]) * f, rgb[a][1] + (rgb[b][1] - rgb[a][1]) * f, rgb[a][2] + (rgb[b][2] - rgb[a][2]) * f); }
    return lut;
  }
  /* the layers for one photo, at stage size: the photo, the subject alone, its gold halo, its dreamy twin */
  var FX = null, FX_SUB = null;
  function freeFx() { if (FX) { free(FX.full); free(FX.cut); free(FX.halo); free(FX.dream); } FX = null; free(FX_SUB); FX_SUB = null; }
  function fxLayers(p, mask) {
    var W = 1000, full = mk(W, W), m = mk(W, W), cut = mk(W, W), halo = mk(W, W), sm = mk(W / 20, W / 20), cx, hx;
    cover(hq(full), p.canvas, W, W); cover(hq(m), mask, W, W);
    cx = hq(cut); cx.drawImage(full, 0, 0); cx.globalCompositeOperation = 'destination-in'; cx.drawImage(m, 0, 0);
    hq(sm).drawImage(m, 0, 0, sm.width, sm.height);
    hx = hq(halo); hx.drawImage(sm, 0, 0, W, W); hx.drawImage(sm, 0, 0, W, W); hx.globalCompositeOperation = 'source-in'; hx.fillStyle = DREAM[3]; hx.fillRect(0, 0, W, W);
    var dw = 500, dream = mk(dw, dw), dx = hq(dream), gl = mk(dw / 10, dw / 10), lut = gradLut(DREAM);
    dx.drawImage(cut, 0, 0, dw, dw);
    try {
      var id = dx.getImageData(0, 0, dw, dw), px = id.data, i, l, j;
      for (i = 0; i < px.length; i += 4) {
        if (!px[i + 3]) continue;
        l = Math.min(255, Math.round((px[i] * .3 + px[i + 1] * .59 + px[i + 2] * .11) / 24) * 24 + 10);   /* a few flat tones, like paint */
        j = l * 3; px[i] = px[i] * .45 + lut[j] * .55; px[i + 1] = px[i + 1] * .45 + lut[j + 1] * .55; px[i + 2] = px[i + 2] * .45 + lut[j + 2] * .55;
      }
      dx.putImageData(id, 0, 0);
    } catch (e) {}
    hq(gl).drawImage(dream, 0, 0, gl.width, gl.height);
    dx.globalCompositeOperation = 'lighter'; dx.globalAlpha = .18; dx.drawImage(gl, 0, 0, dw, dw);
    dx.globalCompositeOperation = 'destination-in'; dx.globalAlpha = 1; dx.drawImage(cut, 0, 0, dw, dw);
    free(m); free(sm); free(gl);
    return { src: p.canvas, full: full, cut: cut, halo: halo, dream: dream, t0: Date.now() };
  }
  var SPARKS = [];
  for (var si0 = 0; si0 < 46; si0++) SPARKS.push({ x: Math.random() * 1000, y: Math.random() * 1000, r: 4 + Math.random() * 9, v: .25 + Math.random() * .7, ph: Math.random() * 6.3 });
  function star(x, cx, cy, r) {
    x.beginPath(); x.moveTo(cx, cy - r); x.quadraticCurveTo(cx, cy, cx + r, cy); x.quadraticCurveTo(cx, cy, cx, cy + r);
    x.quadraticCurveTo(cx, cy, cx - r, cy); x.quadraticCurveTo(cx, cy, cx, cy - r); x.fill();
  }
  function ease(t) { t = Math.max(0, Math.min(1, t)); return t * t * (3 - 2 * t); }
  /* the timeline of the run in progress (ms), spread over the usual painting time: the photo for ~5% of it
     (2.5-5 s), the cut for ~6% (3-5 s: the sweep, then a beat on the cut-out), the dream for the rest, deepest
     by 80% of it and held there until the art is back. The cut waits for the mask if the mask is late */
  var GEN = null;
  function clampN(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function genPlan(dur, t0, blank) {
    var show = clampN(dur * .05, 2500, 5000), cut = clampN(dur * .06, 3000, 5000);
    return { t0: t0, show: show, cut: cut, cutAt: blank ? t0 + show : 0, deep: t0 + Math.max(show + cut + 6000, dur * .8) };
  }
  /* the step on screen: 0 the photo, 1 the cut, 2 the dream */
  function phaseNow() {
    var now = Date.now();
    if (!GEN || !GEN.cutAt || now < GEN.cutAt) return 0;
    return now < GEN.cutAt + GEN.cut ? 1 : 2;
  }
  function drawBusy(cv) {
    var x = cv.getContext('2d'), p = S.photo, W = cv.width, now = Date.now(), i;
    x.setTransform(1, 0, 0, 1, 0, 0); x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    if (!p || !p.canvas || p.blank) { x.fillStyle = FX_BG[0]; x.fillRect(0, 0, W, W); return; }
    if (!FX || FX.src !== p.canvas) {
      if (!FX || FX.wait !== p.canvas) {
        freeFx(); FX = { wait: p.canvas };
        maskFor(p.canvas).then(function (m) {
          if (S.gen !== 'run' || !S.photo || S.photo.canvas !== p.canvas) return;
          FX = fxLayers(p, m);
          if (GEN && !GEN.cutAt) GEN.cutAt = Math.max(GEN.t0 + GEN.show, Date.now());
        });
      }
    }
    /* step 1: the photo as it came in, with a slow breath of light */
    if (!FX.full || phaseNow() === 0) {
      cover(x, p.canvas, W, W);
      x.fillStyle = 'rgba(255,240,210,' + (.05 + .05 * Math.sin(now / 520)) + ')'; x.fillRect(0, 0, W, W);
      return;
    }
    /* step 2: the sweep, then the cut-out alone for a beat; step 3: the dream deepens slowly to its most */
    var k = W / 1000, e = now - GEN.cutAt, SW = RM ? 1 : Math.min(2600, GEN.cut - 600), s = Math.min(1, e / SW), ys = (s * 1.08 - .04) * W;
    var dAt = GEN.cutAt + GEN.cut, d = now < dAt ? 0 : .75 * ease((now - dAt) / Math.max(4000, GEN.deep - dAt));   /* never so dreamy the face is lost */
    /* the new backdrop: night sky in the recipe's colours, with drifting sparkles */
    var g = x.createLinearGradient(0, 0, W * .3, W); g.addColorStop(0, FX_BG[0]); g.addColorStop(1, FX_BG[1]);
    x.fillStyle = g; x.fillRect(0, 0, W, W);
    var rg = x.createRadialGradient(W / 2, W * .45, 0, W / 2, W * .45, W * .62);
    rg.addColorStop(0, 'rgba(255,214,150,' + (.10 + .18 * d) + ')'); rg.addColorStop(1, 'rgba(255,214,150,0)');
    x.fillStyle = rg; x.fillRect(0, 0, W, W);
    x.save(); x.scale(k, k);
    /* the subject: breathing a little, the gold halo behind it, the dreamy twin fading in on top */
    var b = RM ? 1 : 1 + .012 * Math.sin(now / 900);
    x.translate(500, 520); x.scale(b, b); x.translate(-500, -520);
    x.globalAlpha = Math.min(1, s * 1.4) * (.45 + .25 * Math.sin(now / 600)); x.drawImage(FX.halo, 0, 0);
    x.globalAlpha = 1;
    if (!FX_SUB) FX_SUB = mk(1000, 1000);
    var sx = FX_SUB.getContext('2d');
    sx.globalCompositeOperation = 'source-over'; sx.globalAlpha = 1; sx.clearRect(0, 0, 1000, 1000);
    sx.drawImage(FX.cut, 0, 0);
    if (d > 0) { sx.globalAlpha = d; sx.drawImage(FX.dream, 0, 0, 1000, 1000); sx.globalAlpha = 1; }
    if (!RM && d > .05) {   /* a sheen that crosses the subject every few seconds */
      var sp = ((now - dAt) % 3400) / 3400 * 1800 - 400, sg = sx.createLinearGradient(sp - 160, 0, sp + 160, 300);
      sg.addColorStop(0, 'rgba(255,255,255,0)'); sg.addColorStop(.5, 'rgba(255,248,230,' + (.35 * d) + ')'); sg.addColorStop(1, 'rgba(255,255,255,0)');
      sx.globalCompositeOperation = 'source-atop'; sx.fillStyle = sg; sx.fillRect(0, 0, 1000, 1000);
    }
    x.drawImage(FX_SUB, 0, 0);
    x.setTransform(k, 0, 0, k, 0, 0);
    /* sparkles: a few at first, more as it turns dreamy */
    var nS = Math.round(8 + 38 * d);
    for (i = 0; i < nS; i++) {
      var sk = SPARKS[i], yy = RM ? sk.y : (sk.y - (now / 16) * sk.v) % 1000; if (yy < 0) yy += 1000;
      x.globalAlpha = .25 + .55 * (.5 + .5 * Math.sin(now / 380 + sk.ph));
      x.fillStyle = i % 3 ? DREAM[4] : DREAM[3]; star(x, sk.x, yy, sk.r);
    }
    x.globalAlpha = 1;
    x.restore();
    /* still cutting: below the line the photo is untouched, on the line a band of gold light */
    if (s < 1) {
      x.save(); x.beginPath(); x.rect(0, Math.max(0, ys), W, W); x.clip(); x.drawImage(FX.full, 0, 0, W, W); x.restore();
      var lg = x.createLinearGradient(0, ys - 70 * k, 0, ys + 8 * k);
      lg.addColorStop(0, 'rgba(255,217,138,0)'); lg.addColorStop(.85, 'rgba(255,217,138,.55)'); lg.addColorStop(1, 'rgba(255,250,235,.95)');
      x.globalCompositeOperation = 'lighter'; x.fillStyle = lg; x.fillRect(0, ys - 70 * k, W, 78 * k);
      x.globalCompositeOperation = 'source-over'; x.fillStyle = '#fffaf0'; x.fillRect(0, ys, W, 3 * k);
    }
  }
  /* while it paints, the stage is redrawn about 30 times a second (twice a second for reduced motion) */
  var busyRAF = 0;
  function busyLoop() {
    cancelAnimationFrame(busyRAF);
    var last = 0;
    (function tick(t) {
      if (S.gen !== 'run') { busyRAF = 0; freeFx(); return; }
      busyRAF = requestAnimationFrame(tick);
      if (t - last < (RM ? 500 : 33)) return;
      last = t; drawBusy(stageCv);
    })(0);
  }

  /* ======================================================================
     the stage: gallery + studio, and its thumbs
     ====================================================================== */
  var VIEWS = ['On the wall', 'Canvas close-up', 'Compare sizes', 'Before & after', 'Photo guide'];
  var stage = q('stage'), stageCv = q('stageCv'), gal = q('gal');
  var SIZES_OK = SIZES.length > 1 && SIZES.every(function (s) { return s.ok; });
  /* the example has no "before" photo; a size that does not read as W×H turns "Compare sizes" off */
  function viewOk(i) { var cv = curVer(); return i === 2 ? SIZES_OK : i === 3 ? !!(cv && cv.photo) : i === 4 ? !!C.guide : true; }
  function renderStage() {
    var busy = S.gen === 'run', n = VIEWS.length;
    S.view = ((S.view % n) + n) % n; if (!viewOk(S.view)) S.view = 0;
    if (busy) drawBusy(stageCv); else drawView(stageCv, S.view);
    if (curImg() || busy) root.classList.add('is-ready');
    stage.classList.toggle('is-busy', busy); gal.classList.toggle('is-busy', busy);
    stageCv.setAttribute('aria-label', busy ? 'Your photo, being painted by the AI' : VIEWS[S.view]);
    q('cap').textContent = VIEWS[S.view];
    qa('.hzai-gthumb').forEach(function (b, i) { b.setAttribute('aria-selected', String(i === S.view)); b.hidden = !viewOk(i); });
    var yours = !!S.versions.length, bd = q('badge'), yt = typeof C.badge === 'string' ? C.badge.trim() : 'Your AI preview';
    bd.classList.toggle('is-yours', yours && !busy); bd.classList.toggle('is-busy', busy);
    /* on the customer's art the label is the theme setting's; left empty, there is none */
    bd.hidden = yours && !busy && !yt;
    q('badgeT').textContent = busy ? 'Painting · ' + S.pct + '%' : yours ? yt : 'Example';
  }
  function buildThumbs() {
    q('thumbs').innerHTML = VIEWS.map(function (n, i) {
      return '<button class="hzai-gthumb" type="button" role="tab" data-view="' + i + '" aria-selected="false" aria-label="' + esc(n) + '"><canvas width="160" height="160"></canvas></button>';
    }).join('');
  }
  function renderThumbs() { qa('.hzai-gthumb').forEach(function (b, i) { if (viewOk(i)) drawView(b.firstChild, i); }); }
  function setView(v, d) {
    if (S.gen === 'run') return;
    var n = VIEWS.length; v = ((v % n) + n) % n;
    for (var g = 0; g < n && !viewOk(v); g++) v = ((v + (d || 1)) % n + n) % n;
    S.view = v; renderStage();
  }
  q('thumbs').addEventListener('click', function (e) { var b = e.target.closest('[data-view]'); if (b) setView(+b.dataset.view); });
  q('prev').addEventListener('click', function () { setView(S.view - 1, -1); });
  q('next').addEventListener('click', function () { setView(S.view + 1, 1); });
  /* swipe on the stage or the zoom: plain pointer events, no pointer capture. A tap on the stage zooms */
  function swipe(el, onTap) {
    var sx = null, sy = 0, t0 = null;
    el.addEventListener('pointerdown', function (e) { if (e.button > 0) return; sx = e.clientX; sy = e.clientY; t0 = e.target; });
    window.addEventListener('pointerup', function (e) {
      if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy, t = t0; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) setView(S.view + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      else if (onTap && Math.abs(dx) < 8 && Math.abs(dy) < 8 && t && !t.closest('button')) onTap();
    });
    window.addEventListener('pointercancel', function () { sx = null; });
  }
  swipe(stage, openZoom);

  /* zoom: the painting itself (not the room), cut to the chosen size's shape like the print, as big as the
     screen allows and drawn to its real pixels. The customer's art keeps its trademark */
  var zoomCv = q('zoomCv'), zoomM = root.querySelector('[data-hz-modal="zoom"]');
  function zoomOpen() { return !!(zoomM && zoomM.classList.contains('is-open')); }
  function drawZoom() {
    var im = curImg(); if (!im) return;
    var sz = sizeOf(S.size), iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
    var r = S.digitalOnly ? iw / ih : sz.w / sz.h;
    var bw = Math.min(window.innerWidth * .94, window.innerHeight * .9 * r), bh = bw / r, box = q('zoomBox');
    box.style.width = Math.round(bw) + 'px'; box.style.height = Math.round(bh) + 'px';
    var pw = Math.max(1, Math.round(Math.min(bw * (window.devicePixelRatio || 1), Math.min(iw, ih * r)))), ph = Math.round(pw / r);
    zoomCv.width = pw; zoomCv.height = ph; cover(hq(zoomCv), im, pw, ph);
    q('zoomCap').textContent = (S.versions.length ? 'Your art' : 'Example') + (S.digitalOnly ? ' · digital file' : ' · ' + sz.name);
  }
  function openZoom() {
    if (!zoomM || S.gen === 'run' || !curImg()) return;
    openModal('zoom'); drawZoom(); track('zoom', { view: S.view, size: S.size });
  }
  if (zoomM) window.addEventListener('resize', function () { if (zoomOpen()) drawZoom(); });

  /* versions: one per photo; "Upload photo" makes another and costs a token */
  function renderVersions() {
    var box = q('vers'), el = q('versRow'), run = S.gen === 'run', tok = S.tokens;
    if (!S.versions.length && !run) { box.hidden = true; el.innerHTML = ''; return; }
    box.hidden = false;
    q('tokLeft').textContent = tok + ' token' + (tok === 1 ? '' : 's') + ' left';
    el.innerHTML = S.versions.map(function (v, i) {
      return '<button class="hzai-vthumb" type="button" data-ver="' + i + '" aria-pressed="' + (i === S.ver && !run) + '" aria-label="Version ' + (i + 1) + '"' + (v.lettering || v.instr ? ' title="' + esc([v.lettering ? 'Name: ' + v.lettering : '', v.instr].filter(Boolean).join('\n')) + '"' : '') + '><canvas width="88" height="110"></canvas><span>' + (i + 1) + '</span></button>';
    }).join('') + (run
      ? '<span class="hzai-vnew hzai-vnew--run"><span class="hzai-spin" aria-hidden="true"></span>Painting<small data-hz="runPct">' + S.pct + '%</small></span>'
      : '<button class="hzai-vnew" type="button" data-hz="moreBtn"' + (tok < COST ? ' disabled' : '') + '><svg class="hzai-icon" viewBox="0 0 24 24"><path d="M12 16V4"/><path d="M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>'
        + (tok >= COST ? 'New photo<small>new version</small>' : 'No tokens<small>left</small>') + '</button>');
    qa('.hzai-vthumb canvas').forEach(function (c, i) { var v = S.versions[i]; if (v && v.img) cover(hq(c), v.img, 88, 110); });
  }
  q('versRow').addEventListener('click', function (e) {
    if (S.gen === 'run') return;
    if (e.target.closest('[data-hz="moreBtn"]')) { if (S.tokens >= COST) openPicker('more'); return; }
    var b = e.target.closest('[data-ver]'); if (!b) return;
    /* the version brings back its own photo, name and instruction (no photo kept: the upload box opens) */
    S.ver = +b.dataset.ver; S.photo = S.versions[S.ver].photo || null; showDetails(S.versions[S.ver]);
    track('version_select', { version: S.ver + 1 }); renderSteps(); refresh();
  });

  /* ======================================================================
     buy box: size, frame, price, add-ons, quantity
     ====================================================================== */
  function priceOf(size, frame) { var v = variantFor(size, frame); return v ? v.price : null; }
  function renderSizes() {
    var maxW = Math.max.apply(null, SIZES.map(function (s) { return s.w; }));
    qa('[data-size]').forEach(function (b) {
      var s = sizeOf(b.dataset.size), on = s.id === S.size, v = variantFor(s.id, S.frame), iw = Math.round(10 + 18 * s.w / maxW), ih = Math.round(iw * s.h / s.w);
      b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-checked', String(on));
      b.disabled = !v || !v.available;
      var ic = b.querySelector('[data-hz-ic]'); if (ic) { ic.style.width = iw + 'px'; ic.style.height = ih + 'px'; }
      var pr = b.querySelector('[data-hz-price]'); if (pr) pr.innerHTML = v ? moneyHtml(v.price) : '';
    });
    convertMoney();
  }
  /* HTML: the amount sits in .money, so the currency app converts it too */
  function frameNote(f) {
    var p = priceOf(S.size, f.id), base = NO_FRAME ? priceOf(S.size, NO_FRAME.id) : null;
    if (p === null) return '';
    if (!f.ring && NO_FRAME) return 'Gallery wrap, included';
    return base !== null ? '+' + moneyHtml(p - base) : moneyHtml(p);
  }
  function renderFrames() {
    qa('[data-frame]').forEach(function (b) {
      var f = frameOf(b.dataset.frame), on = f.id === S.frame, v = variantFor(S.size, f.id);
      b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-checked', String(on));
      b.disabled = !v || !v.available;
      var pr = b.querySelector('[data-hz-price]'); if (pr) pr.innerHTML = frameNote(f);
    });
    var fv = q('frameV');
    if (fv) { var f = frameOf(S.frame); fv.innerHTML = f.ring ? esc(f.name) + ' floating frame · ' + frameNote(f) : (f.name ? 'Gallery wrap' : ''); }
    convertMoney();
  }
  /* the price says "From" until the customer picks a size or a frame (even the one already on), or has a photo in */
  qa('[data-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      var first = !S.picked; S.picked = true;
      if (b.dataset.size === S.size) { if (first) renderPrice(); return; }
      S.size = b.dataset.size; syncUrl(); renderSizes(); renderFrames(); renderPrice(); track('size_select', { size: S.size });
      if (S.view > 2) S.view = 0; refresh();
    });
  });
  qa('[data-frame]').forEach(function (b) {
    b.addEventListener('click', function () {
      var first = !S.picked; S.picked = true;
      if (b.dataset.frame === S.frame) { if (first) renderPrice(); return; }
      S.frame = b.dataset.frame; syncUrl(); renderFrames(); renderSizes(); renderPrice(); track('frame_select', { frame: S.frame });
      if (S.view > 2) S.view = 0; refresh();
    });
  });
  /* keep ?variant= in the address like the theme does, so a shared link opens the same choice */
  function syncUrl() {
    var v = variantFor(S.size, S.frame); if (!v || !window.history || !history.replaceState) return;
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
  }

  /* add-ons: the tee / mug products picked in the section, same art, never pre-ticked */
  function upVariants(key) { var p = C[key]; return p ? (p.variants || []).filter(function (v) { return v.available !== false; }) : []; }
  function upVariant(key) { var vs = upVariants(key), id = S[key]; for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i]; return vs[0] || null; }
  function renderUpsell() {
    ['tee', 'mug'].forEach(function (key) {
      var sel = root.querySelector('[data-upsize="' + key + '"]'); if (!sel) return;
      var vs = upVariants(key);
      if (!S[key] && vs.length) {
        var pick = vs.filter(function (v) { return /(^|\W)M(\W|$)/.test(v.title); })[0] || vs[0];
        S[key] = pick.id;
      }
      sel.innerHTML = vs.map(function (v) { return '<option value="' + v.id + '"' + (v.id === S[key] ? ' selected' : '') + '>' + esc(v.title) + '</option>'; }).join('');
      sel.hidden = vs.length < 2;
      var pr = root.querySelector('[data-up-price="' + key + '"]'), v = upVariant(key);
      if (pr) pr.innerHTML = v ? '+' + moneyHtml(v.price) : '';
      var cb = root.querySelector('[data-up="' + key + '"]'); if (cb) cb.checked = !!S.addOns[key];
    });
    drawUpsell(); convertMoney();
  }
  function drawUpsell() {
    var up = q('upsell'); if (!up || up.hidden) return;
    var t = root.querySelector('[data-upcv="tee"]'), m = root.querySelector('[data-upcv="mug"]');
    if (t) drawTee(t);
    if (m) { var mv = upVariant('mug'); drawMug(m, mv ? /15/.test(mv.title) : false); }
  }
  if (q('upsell')) {
    q('upsell').addEventListener('change', function (e) {
      var c = e.target.closest('[data-up]');
      if (c) { S.addOns[c.dataset.up] = c.checked; track('addon_toggle', { item: c.dataset.up, on: c.checked }); renderPrice(); return; }
      var z = e.target.closest('[data-upsize]'); if (!z) return;
      /* picking a size is a clear "yes", so it ticks the box (the customer's own action, not a default) */
      S[z.dataset.upsize] = +z.value; S.addOns[z.dataset.upsize] = true; renderUpsell(); renderPrice();
    });
  }
  function addOnTotal() {
    var t = 0;
    if (S.addOns.tee) { var tv = upVariant('tee'); if (tv) t += tv.price; }
    if (S.addOns.mug) { var mv = upVariant('mug'); if (mv) t += mv.price; }
    return t;
  }

  function renderPrice() {
    var run = S.gen === 'run', v = variantFor(S.size, S.frame), f = frameOf(S.frame), extras = (S.addOns.tee ? ' + tee' : '') + (S.addOns.mug ? ' + mug' : '');
    var el = q('price'), add = q('addBtn'), total, exact = S.digitalOnly && C.digital || (S.photo || S.versions.length || S.picked) && v;
    if (S.digitalOnly && C.digital) {
      total = C.digital.price + addOnTotal();
      el.innerHTML = '<span class="hzai-price__now">' + moneyHtml(total) + '</span><span class="hzai-price__note">' + esc('High-res digital file' + extras) + '</span>';
    } else if (exact) {
      total = v.price * S.qty + addOnTotal();
      el.innerHTML = '<span class="hzai-price__now">' + moneyHtml(total) + '</span><span class="hzai-price__note">' + esc((S.qty > 1 ? S.qty + ' × ' : '') + [S.size, f.ring ? f.name + ' frame' : (f.name ? 'Gallery wrap' : '')].filter(Boolean).join(' · ') + extras) + '</span>';
    } else {
      total = MIN_PRICE === Infinity ? 0 : MIN_PRICE;
      el.innerHTML = (VARIANTS.length > 1 ? '<span class="hzai-price__lbl">From</span>' : '') + '<span class="hzai-price__now">' + moneyHtml(total) + '</span>' + (SIZES.length > 1 ? '<span class="hzai-price__note">' + esc(SIZES[0].name + ' to ' + SIZES[SIZES.length - 1].name) + '</span>' : '');
    }
    q('qty').hidden = S.digitalOnly;
    var soldOut = !S.digitalOnly && S.versions.length && (!v || !v.available);
    /* before the first version this button is the next step: upload a photo, then create the art */
    add.textContent = run ? 'Painting your art…' : !S.versions.length ? (S.pend ? 'Create my art' : (q('s1').querySelector('.hzai-step__t') || {}).textContent || 'Upload your photo')
      : soldOut ? 'Sold out' : (S.qty > 1 && !S.digitalOnly ? 'Add ' + S.qty + ' to cart' : 'Add to cart');
    add.disabled = run || !!soldOut;
    q('qMinus').disabled = S.qty <= 1; q('qPlus').disabled = S.qty >= MAXQTY; q('qVal').value = S.qty;
    var mp = q('mbarP'); if (mp) mp.innerHTML = (exact ? '' : (VARIANTS.length > 1 ? 'From ' : '')) + moneyHtml(total);
    var ms = q('mbarS'); if (ms && (S.photo || S.versions.length)) ms.textContent = S.digitalOnly ? 'High-res digital file' : [S.size, f.ring ? f.name + ' frame' : ''].filter(Boolean).join(' · ');
    mbarState(); convertMoney();
  }
  function renderSteps() {
    var has = !!(S.photo || S.pend), art0 = S.versions.length > 0, run = S.gen === 'run', s1 = q('s1'), s2 = q('s2');
    renderCreate();
    s1.classList.toggle('has-photo', has); s1.classList.toggle('is-active', !has);
    if (s2) { s2.classList.toggle('is-active', art0 && !run && !S.digitalOnly); s2.classList.toggle('is-off', S.digitalOnly); }
    var up = q('upsell');
    if (up) { var was = up.hidden; up.hidden = !art0; if (was && art0) renderUpsell(); }
  }
  var dig = q('digital');
  if (dig) dig.addEventListener('change', function () { S.digitalOnly = dig.checked; track('digital_only', { on: S.digitalOnly }); renderSteps(); renderPrice(); refresh(); });
  function setQty(n) { n = parseInt(n, 10); S.qty = clamp(isNaN(n) ? 1 : n, 1, MAXQTY); renderPrice(); }
  q('qMinus').addEventListener('click', function () { setQty(S.qty - 1); });
  q('qPlus').addEventListener('click', function () { setQty(S.qty + 1); });
  q('qVal').addEventListener('input', function () { this.value = this.value.replace(/[^0-9]/g, ''); });
  q('qVal').addEventListener('change', function () { setQty(this.value); });

  /* ======================================================================
     photo in: the drop zone, drag & drop on it or on the stage, "Upload photo" in the versions row.
     A photo only waits (S.pend); the AI paints when the customer presses "Create my art"
     ====================================================================== */
  var fileIn = q('file');
  function openPicker(from) {
    if (S.gen === 'run') { toast('Hang on, your art is still painting…'); return; }
    if (!aiReady()) return;
    track('cta_upload', { from: from }); fileIn.click();
  }
  /* no backend and no test mode: say so instead of taking a photo nobody will paint */
  function aiReady() {
    if (C.api || C.test) return true;
    toast('The AI preview is not switched on yet. Please check back soon.'); return false;
  }
  function prepPhoto(img) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height, s = Math.min(1, 1200 / Math.max(w, h));
    var c = mk(w * s, h * s); hq(c).drawImage(img, 0, 0, c.width, c.height); return c;
  }
  var SENDABLE = /^image\/(jpeg|png|webp)$/;
  /* Customer Instruction: the customer's wishes for the picture (not text printed on it). Read when they
     press "Create my art", so they can type them before or after choosing the photo */
  var instrIn = q('instr');
  function instrNow() { return instrIn ? String(instrIn.value || '').replace(/\r\n?/g, '\n').trim().slice(0, 1000) : ''; }
  /* Name on the art: words the AI paints on the picture (the backend's "lettering"), read the same way */
  var nameIn = q('name');
  function nameNow() { return nameIn ? String(nameIn.value || '').replace(/\s+/g, ' ').trim().slice(0, 40) : ''; }
  /* one painting per photo + name + instruction: the same three again reuse their version, no token */
  function detailsKey(ph) { var nm = nameNow(), ins = instrNow(); return ph ? ph + (ins || nm ? '.' + h32(nm + '\n' + ins) : '') : ''; }
  /* the boxes show what a version was painted with */
  function showDetails(v) {
    detailsTyped = false;
    if (nameIn) nameIn.value = (v && v.lettering) || '';
    if (instrIn) instrIn.value = (v && v.instr) || '';
  }
  /* a new photo starts with empty boxes, unless the customer typed in them since the last painting (then
     those are their wishes for this photo: they may write them before they upload) */
  var detailsTyped = false;
  [nameIn, instrIn].forEach(function (el) { if (el) el.addEventListener('input', function () { detailsTyped = true; renderCreate(); }); });
  function clearDetails() { if (detailsTyped) return; if (nameIn) nameIn.value = ''; if (instrIn) instrIn.value = ''; }
  function handleFile(f, via) {
    if (!f) return;
    if (!aiReady()) return;
    var bm = blockedMinutes();
    if (bm) { toast('Previews are paused on this device for about ' + bm + ' min. Please come back later.'); return; }
    if (S.tokens < COST) { toast('No tokens left. You can still order any of your versions.'); return; }
    if (!/^image\//.test(f.type) && !/\.(jpe?g|png|webp|gif|heic|heif)$/i.test(f.name)) { toast('Please choose an image file (JPG, PNG or WebP).'); return; }
    if (f.size > 15 * 1024 * 1024) { toast('That photo is over 15MB. Please pick a smaller one.'); return; }
    S.upT0 = Date.now(); track('upload_start', { via: via, kb: Math.round(f.size / 1024) });
    hashFile(f).then(function (ph) {
      var u = URL.createObjectURL(f);
      loadImg(u).then(function (img) {
        S.pend = { canvas: prepPhoto(img), file: f, orig: SENDABLE.test(f.type) ? null : img, name: f.name, ph: ph };
        maskFor(S.pend.canvas);   /* the cut-out for the painting show, worked out while the customer reads on */
        clearDetails();
        URL.revokeObjectURL(u);
        track('upload_done', { ms: Date.now() - S.upT0 });
        renderSteps(); renderVersions(); renderPrice();
        /* on phones the next step is the button: bring it into view */
        var cb = q('createBtn'); if (cb && isPhone()) cb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, function () { URL.revokeObjectURL(u); toast('We could not read that photo. Try a JPG or PNG.'); });
    });
  }
  /* "Create my art": the waiting photo, or the current one again when the name / instruction changed */
  function nextPhoto() { return S.pend || S.photo; }
  function canCreate() { var p = nextPhoto(), k; if (!p || S.gen === 'run') return false; k = detailsKey(p.ph); return !(k && S.byHash[k] !== undefined); }
  function renderCreate() {
    var b = q('createBtn'), pend = q('pend'); if (!b) return;
    var show = canCreate();
    b.hidden = !show;
    if (show) {
      b.disabled = S.tokens < COST;
      q('createT').textContent = S.pend ? 'Create my art' : 'Create a new version';
      q('createS').textContent = S.tokens >= COST ? tokWord(COST) : 'no tokens left';
    }
    if (pend) {
      pend.hidden = !S.pend || S.gen === 'run';
      if (S.pend) { q('pendName').textContent = S.pend.name || ''; var c = q('pendCv'); cover(hq(c), S.pend.canvas, c.width, c.height); }
    }
  }
  function createArt(from) {
    if (S.gen === 'run') { toast('Hang on, your art is still painting…'); return; }
    var p = nextPhoto(); if (!p) { openPicker(from || 'create'); return; }
    if (!aiReady()) return;
    var bm = blockedMinutes();
    if (bm) { toast('Previews are paused on this device for about ' + bm + ' min. Please come back later.'); return; }
    var instr = instrNow(), nm = nameNow(), key = detailsKey(p.ph);
    if (key && S.byHash[key] !== undefined) {
      S.ver = S.byHash[key]; S.photo = S.versions[S.ver].photo; S.pend = null; S.view = 0; track('upload_duplicate', {});
      renderSteps(); renderVersions(); renderPrice(); refresh();
      toast('Same photo and details as before. Here is that version.'); return;
    }
    if (S.tokens < COST) { toast('No tokens left. You can still order any of your versions.'); return; }
    if (Date.now() - (+(lsGet(LAST_KEY) || 0)) < COOLDOWN_MS) { toast('Please wait a few seconds before the next painting.'); return; }
    /* a copy per painting, so each version keeps the details it was painted with */
    S.photo = { canvas: p.canvas, file: p.file, orig: p.orig, name: p.name, ph: p.ph, key: key, instr: instr, lettering: nm };
    S.pend = null; detailsTyped = false;
    track('create_click', { from: from || 'button', instruction: !!instr, lettering: !!nm });
    startGen();
  }
  if (q('createBtn')) q('createBtn').addEventListener('click', function () { createArt('button'); });
  if (q('pendChange')) q('pendChange').addEventListener('click', function () { openPicker('change'); });
  fileIn.addEventListener('change', function () { handleFile(fileIn.files[0], 'picker'); fileIn.value = ''; });
  q('drop').addEventListener('click', function (e) { if (!aiReady()) { e.preventDefault(); return; } track('cta_upload', { from: 'step1' }); });
  [q('drop'), stage].forEach(function (el) {
    el.addEventListener('dragover', function (e) { e.preventDefault(); el.classList.add('is-over'); });
    el.addEventListener('dragleave', function () { el.classList.remove('is-over'); });
    el.addEventListener('drop', function (e) { e.preventDefault(); el.classList.remove('is-over'); if (S.gen === 'run') return; handleFile(e.dataTransfer.files[0], 'drop'); });
  });

  /* ======================================================================
     the AI: Cloudflare backend, or the test stand-in
     ====================================================================== */
  var API = String(C.api || '').trim().replace(/\/+$/, ''), POLL_MS = 3000, GIVE_UP_MS = 240000;
  function api(path, opt) {
    return fetch(API + path, opt || {}).then(function (r) {
      if (r.ok) return r;
      return r.json().catch(function () { return {}; }).then(function (j) { var e = new Error(j.error || 'HTTP ' + r.status); e.status = r.status; e.body = j; throw e; });
    });
  }
  /* Cloudflare Turnstile, only when a site key is set: a fresh token for every new painting */
  var tsLoad = null, tsId = null, tsWait = null;
  function tsToken() {
    if (!C.turnstile) return Promise.resolve('');
    if (!tsLoad) tsLoad = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; sc.async = true;
      sc.onload = res; sc.onerror = function () { rej(new Error('captcha')); }; document.head.appendChild(sc);
    });
    return tsLoad.then(function () {
      return new Promise(function (res, rej) {
        tsWait = { res: res, rej: rej };
        if (tsId === null) {
          var box = q('ts') || (function () { var d = document.createElement('div'); d.className = 'hzai-ts'; d.setAttribute('data-hz', 'ts'); q('s1').appendChild(d); return d; })();
          tsId = window.turnstile.render(box, {
            sitekey: C.turnstile, appearance: 'interaction-only', execution: 'execute',
            callback: function (t) { if (tsWait) { tsWait.res(t); tsWait = null; } },
            'error-callback': function () { if (tsWait) { tsWait.rej(new Error('captcha')); tsWait = null; } }
          });
        } else { try { window.turnstile.reset(tsId); } catch (e) {} }
        window.turnstile.execute(tsId);
      });
    });
  }
  /* what goes up: the original file at full size (the print check wants every pixel); HEIC and the
     like (Safari reads them, the AI may not) go up as a full-size JPEG */
  function photoBlob(p) {
    if (p.file && SENDABLE.test(p.file.type)) return Promise.resolve(p.file);
    var im = p.orig || p.canvas, w = im.naturalWidth || im.width, h = im.naturalHeight || im.height, k = Math.min(1, 4096 / Math.max(w, h)), c = mk(w * k, h * k);
    hq(c).drawImage(im, 0, 0, c.width, c.height);
    return new Promise(function (res) { c.toBlob(function (b) { free(c); res(b); }, 'image/jpeg', .92); });
  }
  /* the backend's stages: the least % the bar shows once a stage is reached */
  var API_STAGES = { ingest: 4, analyze: 14, extract: 28, transform: 40, compose: 94, verify: 94 };
  function tokensFrom(j) { if (j && typeof j.tokens_left === 'number') S.tokens = Math.max(0, j.tokens_left) * COST; }
  function generateApi(p, sig) {
    return Promise.all([photoBlob(p), tsToken()]).then(function (r) {
      var qs = '?recipe=' + encodeURIComponent(C.recipe || '') + '&device=' + encodeURIComponent(DEVICE) + (r[1] ? '&ts=' + encodeURIComponent(r[1]) : '') + '&sig=' + b64url(sig)
        + (p.lettering ? '&lettering=' + encodeURIComponent(p.lettering) : '') + (p.instr ? '&instruction=' + encodeURIComponent(p.instr) : '');
      return api('/storefront/previews' + qs, { method: 'POST', headers: { 'content-type': r[0].type || 'image/jpeg' }, body: r[0] });
    }).then(function (r) { return r.json(); }).then(function (j) {
      tokensFrom(j);
      keepPending(j.id, p);
      return waitJob(j.id, p, Date.now() + GIVE_UP_MS);
    });
  }
  /* a started job: ask every 3 s until the art is there, then take it in */
  function waitJob(id, p, giveUpAt) {
    var art = '';
    return new Promise(function (res, rej) {
      var miss = 0;
      (function tick() {
        api('/storefront/previews/' + encodeURIComponent(id)).then(function (r) { return r.json(); }).then(function (st) {
          miss = 0; tokensFrom(st); if (p === S.photo) S.apiStage = st.stage || '';
          /* the backend's own link to the art is the Preview link the order keeps */
          if (st.art) { if (/^https:\/\//.test(st.art)) art = st.art; return api('/storefront/previews/' + encodeURIComponent(id) + '/art').then(function (r) { return r.blob(); }).then(res, rej); }
          if (st.status === 'failed' || st.status === 'needs_attention') { var e = new Error(st.error || st.status); e.code = st.status; return rej(e); }
          if (Date.now() > giveUpAt) { var to = new Error('timeout'); to.code = 'timeout'; return rej(to); }
          setTimeout(tick, POLL_MS);
        }, function (e) { if (++miss < 4 && !(e.status >= 400 && e.status < 500)) setTimeout(tick, POLL_MS); else rej(e); });
      })();
    }).then(function (blob) {
      var u = URL.createObjectURL(blob);
      return loadImg(u).then(function (img) {
        URL.revokeObjectURL(u);
        var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, 1200 / Math.max(w, h)), c = mk(w * k, h * k);
        hq(c).drawImage(img, 0, 0, c.width, c.height); c.keep = true;
        return { img: c, job: id, url: art || API + '/storefront/previews/' + encodeURIComponent(id) + '/art' };
      });
    });
  }
  /* a painting under way survives a reload or a closed tab: its job (and photo) stay in this browser until it ends,
     and the page picks it up again on the next visit (the token is spent already) */
  var PEND_KEY = 'hzai_job_' + (C.recipe || 'x'), PEND_MAX_AGE = 24 * 3600 * 1000;
  function pendingRec() { try { return JSON.parse(lsGet(PEND_KEY) || 'null'); } catch (e) { return null; } }
  function keepPending(id, p) {
    lsSet(PEND_KEY, JSON.stringify({ id: id, t0: Date.now(), ph: p.ph || '', key: p.key || '', instr: p.instr || '', lettering: p.lettering || '' }));
    if (p.canvas && p.ph) canvasBlob(p.canvas, .85).then(function (b) { return idb('photos', 'readwrite', function (s) { s.put({ ph: p.ph, img: b }); }); }).catch(function () {});
  }
  function dropPending() { try { localStorage.removeItem(PEND_KEY); } catch (e) {} }
  function resumePending() {
    var rec = pendingRec();
    if (!rec || !rec.id || C.test || !API || S.gen === 'run') return;
    if (Date.now() - (rec.t0 || 0) > PEND_MAX_AGE) { dropPending(); return; }
    (rec.ph ? idb('photos', 'readonly', function (s) { return s.get(rec.ph); }) : Promise.resolve(null)).catch(function () { return null; }).then(function (row) {
      return row && row.img ? blobCanvas(row.img).catch(function () { return null; }) : null;
    }).then(function (cv) {
      if (S.gen === 'run') return;
      /* no photo kept: a plain dark stand-in for the wait, and the version gets no "before" */
      S.photo = { canvas: cv || mk(4, 5), blank: !cv, name: '', ph: rec.ph, key: rec.key, instr: rec.instr, lettering: rec.lettering };
      S.pend = null;
      startGen({ id: rec.id, t0: rec.t0 });
    });
  }
  /* test mode: no backend. The customer's photo, cropped 3:4, tinted pastel and stamped TEST */
  function generateTest(p) {
    return new Promise(function (res) {
      var steps = ['ingest', 'analyze', 'extract', 'transform', 'compose'], i = 0;
      (function next() {
        if (p === S.photo) S.apiStage = steps[i] || 'compose';
        if (++i <= steps.length) { setTimeout(next, 2900); return; }   /* about 15 s, like a short real run */
        var W = 900, H = 1200, c = mk(W, H), x = hq(c);
        cover(x, p.canvas, W, H);
        var g = x.createLinearGradient(0, 0, W, H); g.addColorStop(0, 'rgba(255,190,230,.30)'); g.addColorStop(1, 'rgba(150,180,255,.30)'); x.fillStyle = g; x.fillRect(0, 0, W, H);
        /* the stamp sits below the band a 4:5 crop takes off the top */
        x.fillStyle = 'rgba(192,57,43,.92)'; x.fillRect(W - 230, 90, 190, 58); x.fillStyle = '#fff'; x.font = '700 32px sans-serif'; x.textAlign = 'center'; x.fillText('TEST', W - 135, 130);
        /* the name, roughly where the recipe paints its golden title (across the top of the sky) */
        if (p.lettering) {
          var fs = 72; x.font = 'italic 700 ' + fs + 'px Georgia, serif';
          while (x.measureText(p.lettering).width > W - 160 && fs > 28) { fs -= 4; x.font = 'italic 700 ' + fs + 'px Georgia, serif'; }
          x.save(); x.textBaseline = 'middle'; x.shadowColor = 'rgba(70,45,0,.6)'; x.shadowBlur = 16; x.fillStyle = '#F6D77A'; x.fillText(p.lettering, W / 2, 240); x.restore();
        }
        c.keep = true;
        res({ img: c, job: 'test-' + Date.now().toString(36), url: '' });
      })();
    });
  }
  /* the trademark over the customer's art: a tiled diagonal mark, baked into the only copy the page keeps, so
     every view, thumb and mock-up shows it. The print file and the Preview link stay clean on the backend */
  function watermark(src) {
    if (!C.wm || !src) return src;
    var W = src.width, H = src.height, c = mk(W, H), x = hq(c), t = String(C.wm.text || 'HISTOZING');
    x.drawImage(src, 0, 0);
    var fs = Math.max(16, Math.round(Math.min(W, H) / 11)), R = Math.sqrt(W * W + H * H) / 2 + fs * 2;
    x.save();
    x.translate(W / 2, H / 2); x.rotate(-Math.PI / 6);
    x.font = '900 ' + fs + 'px Impact, "Arial Black", sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle';
    var tw = x.measureText(t).width + fs * 1.6, step = fs * 2.6, row = 0, y, px;
    x.globalAlpha = clamp(+C.wm.alpha || .24, .05, .6);
    x.lineWidth = Math.max(1, fs / 16); x.strokeStyle = 'rgba(0,0,0,.4)'; x.fillStyle = '#fff';
    for (y = -R; y <= R; y += step, row++) {
      for (px = -R + (row % 2) * tw / 2; px <= R; px += tw) { x.strokeText(t, px, y); x.fillText(t, px, y); }
    }
    x.restore();
    c.keep = true; src.keep = false; free(src);
    return c;
  }
  /* what the customer reads when the AI could not finish (the backend's answers: see the top of this file) */
  function genError(e) {
    var m = String(e && e.message || ''), b = (e && e.body) || {}, s = e && e.status;
    if (b.error === 'blocked') return 'Previews are paused on this device. Please contact us if this is a mistake.';
    if (s === 429) {
      if (b.retry_after > 90) return 'You have made a lot of previews. Please try again in ' + Math.ceil(b.retry_after / 60) + ' min.';
      if (b.retry_after > 0) return 'Lots of previews right now. Please try again in a minute.';
      return 'You have used all your free previews for today. You can still order any of your versions.';
    }
    if (s === 400) return 'AI previews are not available for this product yet.';
    if (s === 403 || /captcha/i.test(m)) return 'We could not check that you are not a robot. Please reload the page and try again.';
    if (s === 413) return 'That photo is over 15MB. Please pick a smaller one.';
    if (s === 415) return 'Please use a JPG, PNG or WebP photo.';
    if (s === 503) return 'We are very busy right now. Please try again in a little while.';
    if (/many_people|expects one person/i.test(m)) return 'We need a photo of just one person. Please try another photo.';
    if (/no_person|no person detected/i.test(m)) return 'We couldn’t find a person in this photo. Please try a clearer one.';
    if (e && e.code === 'timeout') return 'This is taking longer than usual. Please try again.';
    /* a failed job: the backend words its error for the customer */
    if (e && e.code === 'failed' && m && m !== 'failed') return m.slice(0, 220);
    return 'Something went wrong while painting. Please try again.';
  }
  /* the steps the waiting customer sees, one line each, ticked off as the show on the picture moves on (the photo,
     the cut, the dream). A story to make the wait feel shorter; the % and the time left are the honest part */
  var GEN_STEPS = ['Studying your photo', 'Removing the background', 'Adding the magic'];
  (function () { var ol = q('busySteps'); if (ol) ol.innerHTML = GEN_STEPS.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join(''); })();
  /* while it paints: a small review popup on the picture, under the panel, a new one every few seconds.
     The customer can close it; it stays closed for the visit */
  var genTimer = 0, revTimer = 0, revI = 0, revClosed = false;
  var WAIT = (C.wait || []).filter(function (r) { return r && r.q; });
  var revPop = q('revPop');
  function showWaitReview() {
    var inEl = q('revPopIn'); if (!revPop || !inEl || !WAIT.length || revClosed) return;
    var r = WAIT[revI % WAIT.length]; revI++;
    var fill = function () {
      inEl.innerHTML = (r.img ? '<img src="' + esc(r.img) + '" alt="" width="80" height="100">' : '') + '<div><p class="hzai-revpop__q">“' + esc(r.q) + '”</p><p class="hzai-revpop__m"><span class="hzai-st">★★★★★</span> <b>' + esc(r.n) + '</b>' + (r.tag ? ' · ' + esc(r.tag) : '') + '</p></div>';
      inEl.classList.remove('is-swap');
    };
    if (revPop.hidden) { fill(); revPop.hidden = false; requestAnimationFrame(function () { revPop.classList.add('is-on'); }); }
    else { inEl.classList.add('is-swap'); setTimeout(fill, 260); }
  }
  function hideWaitReview() {
    clearInterval(revTimer);
    if (!revPop || revPop.hidden) return;
    revPop.classList.remove('is-on');
    setTimeout(function () { if (!revPop.classList.contains('is-on')) revPop.hidden = true; }, 300);
  }
  if (revPop && q('revPopX')) q('revPopX').addEventListener('click', function () { revClosed = true; hideWaitReview(); track('wait_review_closed', {}); });
  /* resume: {id, t0} of a job started on an earlier visit; it is followed, not started (no token, no new signals) */
  function startGen(resume) {
    if (!S.photo || S.gen === 'run' || (!resume && S.tokens < COST)) return;
    var src = S.photo, dur = C.test ? 15000 : (C.expectMs || 75000), t0 = resume ? resume.t0 : Date.now(), out = null, ready = false, failed = null, sig = resume ? null : signals(src.ph, src.key);
    if (!resume) { STARTED++; lsSet(LAST_KEY, String(Date.now())); lsSet(STARTS_KEY, String(sig.nd + 1)); phBump(src.key || src.ph); }
    S.gen = 'run'; S.view = 0; S.pct = 0; S.apiStage = ''; if (!resume) S.tokens -= COST;
    GEN = genPlan(dur, t0, !!src.blank);
    track(resume ? 'generate_resume' : 'generate_start', { tokens_left: S.tokens, test: !!C.test });
    revI = Math.floor(Math.random() * 7); showWaitReview();
    clearInterval(revTimer); revTimer = setInterval(showWaitReview, 4500);
    renderGen(0, Math.ceil(dur / 1000)); renderStage(); renderVersions(); renderSteps(); renderPrice(); busyLoop();
    /* on phones the buy box sits under the gallery: bring the picture into view for the wait */
    if (isPhone()) { var r = stage.getBoundingClientRect(); if (r.top < 0 || r.top > innerHeight * .4) stage.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    (resume ? waitJob(resume.id, src, Date.now() + GIVE_UP_MS) : C.test ? generateTest(src) : generateApi(src, sig)).then(function (o) {
      o.img = watermark(o.img); o.photo = src.blank ? null : src; o.ph = src.ph; o.key = src.key; o.instr = src.instr; o.lettering = src.lettering; out = o; ready = true;
    }, function (e) { failed = e || new Error('failed'); ready = true; });
    clearInterval(genTimer);
    genTimer = setInterval(function () {
      var t = Math.min(1, (Date.now() - t0) / dur), p = 100 * (1 - Math.pow(1 - t, 1.7)), st = API_STAGES[S.apiStage];
      if (st) p = Math.max(p, st);
      if (!ready) p = Math.min(p, 94);
      renderGen(ready ? 100 : p, Math.ceil((1 - t) * dur / 1000));
      if (!ready) return;
      clearInterval(genTimer); hideWaitReview(); dropPending();
      if (src !== S.photo) return;
      if (failed) {
        var fb = failed.body || {};
        /* a failed run gives the token back, unless the backend says how many are left (a resumed one never took it here) */
        if (typeof fb.tokens_left === 'number') S.tokens = Math.max(0, fb.tokens_left) * COST; else if (!resume) S.tokens += COST;
        /* none left today: kept on this device, so a reload does not offer tokens the backend will refuse */
        if (failed.status === 429 && !(fb.retry_after > 0)) { S.tokens = 0; writeUsed(Math.max(readUsed(), C.tokens || 5)); }
        S.gen = S.versions.length ? 'done' : 'idle';
        S.photo = S.versions.length ? S.versions[S.ver].photo : null;
        /* the photo waits again, so "Create my art" can try once more (or the customer changes it) */
        S.pend = src.blank ? null : { canvas: src.canvas, file: src.file, orig: src.orig, name: src.name, ph: src.ph };
        /* the backend said stop: wait it out on this device (retry_after seconds, or 30 min for a block) */
        if (failed.status === 429 && fb.retry_after > 90) lsSet(BLOCK_KEY, String(Date.now() + fb.retry_after * 1000));
        if (fb.error === 'blocked') lsSet(BLOCK_KEY, String(Date.now() + (fb.retry_after || 1800) * 1000));
        renderVersions(); renderSteps(); renderPrice(); refresh();
        toast(genError(failed)); track('generate_error', { error: String(failed.message || '') }); return;
      }
      writeUsed(readUsed() + COST);
      finishGen(out, !!resume);
    }, 100);
  }
  function finishGen(v, resumed) {
    var first = !S.versions.length;
    v.created = Date.now();
    S.versions.push(v); S.ver = S.versions.length - 1; S.gen = 'done'; S.view = 0;
    if (v.key || v.ph) S.byHash[v.key || v.ph] = S.ver;
    saveVersion(v);
    track('preview_shown', { version: S.versions.length, ms_since_upload: Date.now() - S.upT0 });
    renderSteps(); renderPrice(); refresh();
    toast(resumed ? '✨ Welcome back! Your art is ready.' : first ? '✨ Your art is ready. Here it is on your wall!' : '✨ New version ready. Compare them under Your versions.');
    if (isPhone()) { var r = stage.getBoundingClientRect(); if (r.top < 0 || r.bottom > innerHeight) stage.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
  /* ======================================================================
     history: every version this browser painted for this recipe. The list is JSON in localStorage
     (hzai_history_<recipe>, oldest first): job id, when, preview link, name, instruction, recipe. The pictures
     (the art as the page shows it, so with the trademark when that is on, and the photo it came from) are
     cached in IndexedDB; an art missing there is fetched again from its preview link. A customer who comes
     back finds "Your versions" again and can order any of them. Nothing leaves the browser
     ====================================================================== */
  var HIST_MAX = 50, DBP = null, HIST_KEY = 'hzai_history_' + (C.recipe || 'x');
  function histList() { try { var a = JSON.parse(lsGet(HIST_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function histEntry(v) {
    return { id: v.job, created: new Date(v.created || Date.now()).toISOString(), preview: v.url || '', name: v.lettering || '', instruction: v.instr || '',
             recipe: C.recipe || '', test: /^test-/.test(v.job), ph: v.ph || '', key: v.key || '' };
  }
  /* add or update one job, in place, keeping the newest HIST_MAX */
  function histPut(v) {
    var list = histList(), e = histEntry(v), at = -1;
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].id === e.id) at = i;
    if (at >= 0) list[at] = e; else list.push(e);
    while (list.length > HIST_MAX) list.shift();
    lsSet(HIST_KEY, JSON.stringify(list));
  }
  function db() {
    if (!DBP) {
      DBP = new Promise(function (res, rej) {
        if (!window.indexedDB) { rej(new Error('no indexedDB')); return; }
        var rq = indexedDB.open('hzai', 1);
        rq.onupgradeneeded = function () {
          var d = rq.result;
          if (!d.objectStoreNames.contains('versions')) d.createObjectStore('versions', { keyPath: 'id' }).createIndex('recipe', 'recipe');
          if (!d.objectStoreNames.contains('photos')) d.createObjectStore('photos', { keyPath: 'ph' });
        };
        rq.onsuccess = function () { res(rq.result); };
        rq.onerror = function () { rej(rq.error); };
      });
      DBP.catch(function () {});
    }
    return DBP;
  }
  /* one transaction; fn may return a request, whose result comes back once the transaction is done */
  function idb(store, mode, fn) {
    return db().then(function (d) {
      return new Promise(function (res, rej) {
        var tx = d.transaction(store, mode), rq = fn(tx.objectStore(store));
        tx.oncomplete = function () { res(rq && 'result' in rq ? rq.result : undefined); };
        tx.onerror = tx.onabort = function () { rej(tx.error); };
      });
    });
  }
  function canvasBlob(c, qual) { return new Promise(function (res) { c.toBlob(function (b) { res(b); }, 'image/jpeg', qual); }); }
  function blobCanvas(b) {
    var u = URL.createObjectURL(b);
    return loadImg(u).then(function (im) { URL.revokeObjectURL(u); var c = mk(im.naturalWidth, im.naturalHeight); hq(c).drawImage(im, 0, 0); c.keep = true; return c; });
  }
  function saveVersion(v) {
    if (!v || !v.img || !v.job) return;
    histPut(v);
    var p = v.photo || {};
    Promise.all([canvasBlob(v.img, .88), p.canvas && p.ph ? canvasBlob(p.canvas, .85) : null]).then(function (r) {
      var rec = { id: v.job, recipe: C.recipe || '', created: v.created || Date.now(), url: v.url || '', instr: v.instr || '', lettering: v.lettering || '',
                  ph: v.ph || '', key: v.key || '', test: /^test-/.test(v.job), wm: !!C.wm, art: r[0] };
      return idb('versions', 'readwrite', function (s) { s.put(rec); }).then(function () {
        if (r[1]) return idb('photos', 'readwrite', function (s) { s.put({ ph: p.ph, img: r[1] }); });
      });
    }).then(pruneHistory).catch(function () {});
  }
  /* the newest HIST_MAX per recipe stay; photos nobody points at go */
  function pruneHistory() {
    return idb('versions', 'readonly', function (s) { return s.getAll(); }).then(function (all) {
      var mine = all.filter(function (r) { return r.recipe === (C.recipe || ''); }).sort(function (a, b) { return a.created - b.created; });
      var drop = mine.slice(0, Math.max(0, mine.length - HIST_MAX)).map(function (r) { return r.id; }), keep = {};
      all.forEach(function (r) { if (drop.indexOf(r.id) < 0 && r.ph) keep[r.ph] = 1; });
      var pend = pendingRec(); if (pend && pend.ph) keep[pend.ph] = 1;   /* a job still running keeps its photo */
      return idb('versions', 'readwrite', function (s) { drop.forEach(function (id) { s.delete(id); }); }).then(function () {
        return idb('photos', 'readwrite', function (s) { var rq = s.getAllKeys(); rq.onsuccess = function () { rq.result.forEach(function (k) { if (!keep[k]) s.delete(k); }); }; });
      });
    });
  }
  function restoreHistory() {
    var list = histList();
    return idb('versions', 'readonly', function (s) { return s.index('recipe').getAll(C.recipe || ''); }).catch(function () { return []; }).then(function (recs) {
      var byId = {};
      /* the list decides; pictures cached before the list existed join it once */
      (recs || []).forEach(function (r) {
        byId[r.id] = r;
        if (!list.some(function (h) { return h && h.id === r.id; })) list.push(histEntry({ job: r.id, created: r.created, url: r.url, lettering: r.lettering, instr: r.instr, ph: r.ph, key: r.key }));
      });
      /* test-mode pictures never come back once the page paints for real: they have no art on the backend */
      list = list.filter(function (h) { return h && h.id && (C.test || !h.test); })
        .sort(function (x, y) { return (Date.parse(x.created) || 0) - (Date.parse(y.created) || 0); }).slice(-HIST_MAX);
      if (!list.length) return;
      lsSet(HIST_KEY, JSON.stringify(list));
      return idb('photos', 'readonly', function (s) { return s.getAll(); }).catch(function () { return []; }).then(function (photos) {
        var byPh = {}, phCv = {};
        (photos || []).forEach(function (p) { byPh[p.ph] = p.img; });
        /* arts missing from the cache come again from their preview links: the newest 12 at most */
        var refetch = list.filter(function (h) { return !(byId[h.id] && byId[h.id].art) && h.preview && !h.test; }).slice(-12).map(function (h) { return h.id; });
        return Promise.all(list.map(function (h) {
          var r = byId[h.id], pp = h.ph && byPh[h.ph] ? (phCv[h.ph] = phCv[h.ph] || blobCanvas(byPh[h.ph])) : Promise.resolve(null);
          var ap = r && r.art ? blobCanvas(r.art).then(function (c) { return { c: c, wm: r.wm }; })
            : refetch.indexOf(h.id) >= 0 ? fetch(h.preview).then(function (x) { if (!x.ok) throw new Error('art'); return x.blob(); }).then(blobCanvas).then(function (c) { return { c: c, wm: false, fresh: true }; })
            : Promise.resolve(null);
          return Promise.all([ap, pp]).then(function (x) {
            if (!x[0]) return null;
            var v = { img: C.wm && !x[0].wm ? watermark(x[0].c) : x[0].c, job: h.id, url: h.preview, instr: h.instruction, lettering: h.name, ph: h.ph, key: h.key,
                      created: Date.parse(h.created) || Date.now(), saved: { wm: x[0].wm },
                      photo: x[1] ? { canvas: x[1], name: '', ph: h.ph, key: h.key, instr: h.instruction, lettering: h.name } : null };
            if (x[0].fresh) saveVersion(v);   /* back in the cache */
            return v;
          }, function () { return null; });
        }));
      }).then(function (vs) {
        vs = vs.filter(Boolean);
        /* the customer already started while this loaded: what is on screen wins */
        if (!vs.length || S.versions.length || S.gen === 'run') return;
        S.versions = vs; S.byHash = {};
        vs.forEach(function (v, i) { if (v.key || v.ph) S.byHash[v.key || v.ph] = i; });
        /* the upload box stays as it is, "Your versions" sits under it: a returning customer can order an old
           version or start a new one. Picking a version brings its photo back (for "Create a new version") */
        S.ver = vs.length - 1; S.gen = 'done'; S.view = 0;
        /* the boxes show what the latest version was painted with, so "Create a new version" stays hidden */
        if (nameIn && !nameIn.value) nameIn.value = vs[S.ver].lettering || '';
        if (instrIn && !instrIn.value) instrIn.value = vs[S.ver].instr || '';
        renderSteps(); renderVersions(); renderPrice(); refresh();
        /* the trademark was switched off after these were kept: the clean art comes back from the backend */
        if (!C.wm) vs.forEach(function (v) { if (v.saved.wm && v.url) refetchClean(v); });
        track('history_restored', { versions: vs.length });
      });
    }).catch(function () {});
  }
  function refetchClean(v) {
    fetch(v.url).then(function (r) { if (!r.ok) throw new Error('art'); return r.blob(); }).then(blobCanvas).then(function (c) {
      v.img = c; v.saved.wm = false; refresh(); saveVersion(v);
    }).catch(function () {});
  }

  function renderGen(p, eta) {
    if (S.gen !== 'run') { mbarState(); return; }
    var pct = Math.round(p || 0), si = phaseNow(), ol = q('busySteps'); S.pct = pct;
    q('busyPct').textContent = pct + '%'; q('busyBar').style.width = pct + '%';
    var t = pct >= 100 ? 'Your art is ready!' : GEN_STEPS[si] + '…', bs = q('busyStep'); if (bs.textContent !== t) bs.textContent = t;
    if (ol) Array.prototype.forEach.call(ol.children, function (li, i) { li.className = pct >= 100 || i < si ? 'is-done' : i === si ? 'is-now' : ''; });
    var rp = q('runPct'); if (rp) rp.textContent = pct + '%';
    q('busyEta').textContent = pct >= 100 ? 'Done!' : eta > 0 ? 'About ' + eta + ' second' + (eta === 1 ? '' : 's') + ' left' : 'Almost there…';
    q('badgeT').textContent = 'Painting · ' + pct + '%';
    mbarState();
  }

  /* ======================================================================
     refresh: the stage now, everything else right after
     ====================================================================== */
  var rT = 0, rT2 = 0;
  function refresh() {
    clearTimeout(rT); rT = setTimeout(function () {
      renderStage();
      clearTimeout(rT2); rT2 = setTimeout(function () { renderThumbs(); renderVersions(); drawUpsell(); drawMbar(); }, 30);
    }, 0);
  }

  /* ======================================================================
     add to cart: Shopify's cart (/cart/add.js), then Minimog's own drawer
     ====================================================================== */
  function addToCart(from) {
    if (S.gen === 'run') { toast('Hang on, your art is still painting…'); return; }
    if (!S.versions.length) { if (S.pend) createArt(from || 'add'); else openPicker(from || 'add'); return; }
    /* _Preview starts with "_": Shopify keeps it out of the cart, checkout and customer emails; the order in admin shows it */
    var v = curVer(), props = { _ai_job: v.job, _ai_recipe: C.recipe || '' }, items = [];
    if (v.url) props._Preview = v.url;
    keepThumb(v);
    if (v.lettering) props['Name on art'] = v.lettering;
    if (v.instr) props['Customer Instruction'] = v.instr;
    if (S.digitalOnly && C.digital) items.push({ id: C.digital.id, quantity: 1, properties: props });
    else {
      var pv = variantFor(S.size, S.frame);
      if (!pv || !pv.available) { toast('That size and frame is sold out.'); return; }
      items.push({ id: pv.id, quantity: S.qty, properties: props });
    }
    ['tee', 'mug'].forEach(function (k) { var uv = S.addOns[k] && upVariant(k); if (uv) items.push({ id: uv.id, quantity: 1, properties: props }); });
    var btns = [q('addBtn'), q('mbarBtn')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });
    var body = { items: items };
    if (cartDrawer()) { body.sections = 'cart-drawer'; body.sections_url = location.pathname; }   /* the drawer's new HTML comes back with the add */
    fetch((C.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'We could not add this to your cart.'); return j; }); })
      .then(function (j) {
        track('add_to_cart', { items: items.length, digital: S.digitalOnly, size: S.size, frame: S.frame, qty: S.qty, from: from });
        S.addOns = { tee: false, mug: false }; renderUpsell(); renderPrice();
        openCart(j);
      })
      .catch(function (e) { toast(e.message); })
      .then(function () { btns.forEach(function (b) { b.disabled = false; }); renderPrice(); });
  }
  /* the cart shows the art too (snippets/hzai-cart-image.liquid): a small copy of the watermarked art, kept in this
     browser under its job id. It is a picture, not a link, so the clean art's address never reaches the cart */
  function keepThumb(v) {
    if (!v || !v.job || !v.img) return;
    try {
      var w = 360, h = Math.round(w * v.img.height / v.img.width), c = mk(w, h), u, list;
      hq(c).drawImage(v.img, 0, 0, w, h);
      u = c.toDataURL('image/jpeg', .82); free(c);
      list = JSON.parse(lsGet('hzai_thumbs') || '[]').filter(function (j) { return j !== v.job; });
      list.push(v.job);
      while (list.length > 12) localStorage.removeItem('hzai_thumb_' + list.shift());
      localStorage.setItem('hzai_thumb_' + v.job, u); lsSet('hzai_thumbs', JSON.stringify(list));
    } catch (e) {}
  }
  /* what Minimog's own product form does after an add: refresh + open its cart drawer */
  /* the store's Minimog: the drawer is the <m-cart-drawer> element. Like the theme's own product form, the add asks
     for the drawer's new HTML in the same answer (Section Rendering API), the drawer renders it and opens. Older
     Minimog builds expose MinimogTheme.Cart instead; with neither, the cart page */
  function cartDrawer() {
    var d = document.querySelector('m-cart-drawer'), ms = window.MinimogSettings;
    return d && typeof d.renderContents === 'function' && !(ms && ms.enable_cart_drawer === false) ? d : null;
  }
  function openCart(j) {
    var T = window.MinimogTheme || {}, E = window.MinimogEvents, d = cartDrawer(), cart = T.Cart;
    if (d && j && j.sections && j.sections['cart-drawer']) {
      var shown = false;
      try { d.renderContents(j); shown = true; } catch (e) {}
      if (shown) {   /* once the drawer is open, nothing below may send the customer to the cart page */
        try { if (T.Notification && T.Notification.show && window.MinimogStrings) T.Notification.show({ target: d.querySelector('m-cart-drawer-items'), method: 'prepend', type: 'success', message: window.MinimogStrings.itemAdded, delay: 400 }); } catch (e) {}
        try { if (E && E.emit && T.pubSubEvents) E.emit(T.pubSubEvents.cartUpdate, j); } catch (e) {}   /* the header count follows */
        return;
      }
    }
    try { if (E && E.emit) E.emit('ON_ITEM_ADDED', j); } catch (e) {}
    if (cart && cart.refreshCart) {
      Promise.resolve(cart.refreshCart())
        .then(function () { return cart.renderNewCart && cart.renderNewCart(); })
        .then(function () { if (cart.openCartDrawer) cart.openCartDrawer(); })
        .catch(function () { location.href = C.cartUrl || '/cart'; });
    } else location.href = C.cartUrl || '/cart';
  }
  q('addBtn').addEventListener('click', function () { addToCart('add'); });

  /* ======================================================================
     mobile sticky bar, modals, timeline
     ====================================================================== */
  var mbar = q('mbar');
  function mbarState() {
    var b = q('mbarBtn'); if (!b) return;
    if (S.gen === 'run') { b.textContent = 'Painting… ' + S.pct + '%'; b.disabled = true; return; }
    b.disabled = false; b.textContent = S.versions.length ? 'Add to cart' : S.pend ? 'Create my art' : 'Upload photo';
  }
  function drawMbar() {
    var c = q('mbarCv'); if (!c || !curImg()) return;
    var x = hq(c), W = c.width, H = c.height, fr = look().ring; x.clearRect(0, 0, W, H);
    if (!fr) { x.drawImage(poster(.8), 0, 0, W, H); return; }
    gapFill(x, 3, 3, W - 6, H - 6); x.drawImage(poster(.8), 9, 11, W - 18, H - 22); ring(x, fr, 0, 0, W, H, 6);
  }
  function onScroll() {
    if (!mbar) return;
    if (!isPhone()) { mbar.classList.add('is-off'); return; }
    /* only once the in-page Add to cart has scrolled up out of sight, never over the preview */
    var row = root.querySelector('.hzai-buyrow');
    mbar.classList.toggle('is-off', !row || row.getBoundingClientRect().bottom >= 0);
  }
  if (mbar) {
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    q('mbarBtn').addEventListener('click', function () { addToCart('mbar'); });
  }
  /* Minimog's sticky header slides back in on scroll-up, over the top of the sticky gallery:
     while it shows, --hzai-hdr holds its height and the gallery sits below it (see the css) */
  var hdr = document.querySelector('.sf-header'), hdrBox = hdr && hdr.querySelector('.header__wrapper');
  function syncHeader() {
    var on = hdr.classList.contains('stuck') && !hdr.classList.contains('scroll-down');
    root.style.setProperty('--hzai-hdr', on ? hdrBox.offsetHeight + 'px' : '0px');
  }
  if (hdrBox && window.MutationObserver) {
    new MutationObserver(syncHeader).observe(hdr, { attributes: true, attributeFilter: ['class'] });
    if (window.ResizeObserver) new ResizeObserver(syncHeader).observe(hdrBox);
    syncHeader();
  }
  var lastFocus = null;
  function openModal(id) {
    var m = root.querySelector('[data-hz-modal="' + id + '"]'); if (!m) return;
    lastFocus = document.activeElement; m.classList.add('is-open'); document.body.style.overflow = 'hidden';
    setTimeout(function () { var x = m.querySelector('.hzai-modal__x'); if (x) x.focus(); }, 30);
  }
  function closeModals() {
    qa('.hzai-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    if (zoomCv) { zoomCv.width = zoomCv.height = 10; }   /* a big canvas holds memory on phones until it shrinks */
    document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-hz-open]'); if (o) { e.preventDefault(); openModal(o.dataset.hzOpen); return; }
    if (e.target.closest('[data-hz-close]') || e.target.classList.contains('hzai-modal')) closeModals();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.querySelector('.hzai-modal.is-open')) closeModals();
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && stage.contains(document.activeElement)) setView(S.view + (e.key === 'ArrowRight' ? 1 : -1), e.key === 'ArrowRight' ? 1 : -1);
  });
  function addBiz(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function range(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' - ' + fmt(b); }
  function renderDates() {
    var tl = q('timeline'); if (!tl) return;
    var L = C.lead || {}, now = new Date(), p1 = addBiz(now, L.printMin || 2), p2 = addBiz(now, Math.max(L.printMin || 2, L.printMax || 3)),
        d1 = addBiz(now, L.shipMin || 5), d2 = addBiz(now, Math.max(L.shipMin || 5, L.shipMax || 8));
    var ic = {
      o: '<svg class="hzai-icon" viewBox="0 0 24 24"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M6 6L5 2H2"/></svg>',
      s: '<svg class="hzai-icon" viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
      d: '<svg class="hzai-icon" viewBox="0 0 24 24"><path d="M3 11l9-7 9 7v9H3z"/><path d="M9 20v-6h6v6"/></svg>'
    };
    tl.innerHTML = '<li><span class="hzai-tl__dot">' + ic.o + '</span><b>' + fmt(now) + '</b>Order placed</li><li><span class="hzai-tl__dot">' + ic.s + '</span><b>' + range(p1, p2) + '</b>Printed, stretched &amp; shipped</li><li><span class="hzai-tl__dot">' + ic.d + '</span><b>' + range(d1, d2) + '</b>Delivered</li>';
  }

  /* ======================================================================
     boot
     ====================================================================== */
  buildThumbs(); renderSizes(); renderFrames(); renderSteps(); renderPrice(); renderDates();
  Object.keys(FRAME_RING).forEach(function (k) {
    if (FRAME_RING[k].src) loadImg(FRAME_RING[k].src).then(function (im) { FRAME_RING[k].img = im; refresh(); }, function () {});
  });
  if (C.guide) loadImg(C.guide).then(function (im) { GUIDE = im; refresh(); }, function () {});
  if (C.example) loadImg(C.example).then(function (im) { S.example = im; refresh(); }, function () { root.classList.add('is-ready'); });
  else root.classList.add('is-ready');
  onScroll();
  restoreHistory().then(resumePending);
  track('view_item', { product: P.handle || '' });
  root.__hzaiDebug = { S: S, refresh: refresh, variantFor: variantFor, signals: signals, busy: busyLoop };   /* for QA */
}

function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-hzai]'), boot); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-hzai]'); if (r) boot(r); });
})();
